import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/**
	 * The `Date` scalar type represents a date. The Date appears in a JSON
	 * response as an ISO8601 formatted string, without a time component.
	 */
	Date: { input: string; output: string };
	/**
	 * The `DateTime` scalar type represents a date and time in the UTC
	 * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
	 * string, including UTC timezone ("Z"). The parsed date and time string will
	 * be converted to UTC if there is an offset.
	 */
	DateTime: { input: string; output: string };
	/**
	 * The `Decimal` scalar type represents signed double-precision fractional
	 * values parsed by the `Decimal` library. The Decimal appears in a JSON
	 * response as a string to preserve precision.
	 */
	Decimal: { input: string; output: string };
	/**
	 * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
	 * character sequences. The Json type is most often used to represent a free-form
	 * human-readable json string.
	 */
	Json: { input: { [key: string]: any }; output: { [key: string]: any } };
	/**
	 * The `Money` scalar type represents a monetary value with a currency. The value
	 * is represented as a string in the format `"100.00 MXN"` or `"MXN 100.00"`.
	 */
	Money: { input: string; output: string };
	/**
	 * The `UUID7` scalar type represents UUID7 compliant string data, represented as UTF-8
	 * character sequences.
	 */
	UUID7: { input: string; output: string };
};

export enum AccountType {
	FIXED_PAYMENTS = 'FIXED_PAYMENTS',
	MORTGAGE = 'MORTGAGE',
	REPORT_ONLY = 'REPORT_ONLY',
	REVOLVING = 'REVOLVING',
	WITHOUT_PRESET_LIMIT = 'WITHOUT_PRESET_LIMIT'
}

/** The action failed due to an unexpected reason. */
export type ActionFailed = {
	__typename?: 'ActionFailed';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

export type AddressAnalysis = {
	__typename?: 'AddressAnalysis';
	error?: Maybe<Scalars['String']['output']>;
	isInHighRiskLocation?: Maybe<Scalars['Boolean']['output']>;
	isInsideOfPrison?: Maybe<Scalars['Boolean']['output']>;
	isNearToPrison?: Maybe<Scalars['Boolean']['output']>;
	isOutsideOfTerritory?: Maybe<Scalars['Boolean']['output']>;
	validatedFullAddress?: Maybe<Scalars['String']['output']>;
};

export enum AddressType {
	BUSINESS = 'BUSINESS',
	HOUSE = 'HOUSE',
	POSTAL_BOX = 'POSTAL_BOX',
	USER_ADDRESS = 'USER_ADDRESS'
}

export type AntifraudAnalysis = {
	__typename?: 'AntifraudAnalysis';
	address?: Maybe<AddressAnalysis>;
	curp?: Maybe<CurpAnalysis>;
	email?: Maybe<EmailAnalysis>;
	identityFraudScore?: Maybe<Scalars['Int']['output']>;
	ine?: Maybe<IneAnalysis>;
	ipAddress?: Maybe<IpAddressAnalysis>;
	label?: Maybe<Scalars['String']['output']>;
	location?: Maybe<AddressAnalysis>;
	locationAndAddressDistance?: Maybe<LocationAndAddressDistanceAnalysis>;
	officialIdCurp?: Maybe<CurpAnalysis>;
	officialIdFaceRecognition?: Maybe<FaceRecognitionAnalysis>;
	officialIdRfc?: Maybe<RfcAnalysis>;
	passport?: Maybe<PassportAnalysis>;
	pep?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
	phoneNumber?: Maybe<PhoneNumberAnalysis>;
	rfc?: Maybe<RfcAnalysis>;
	sanctions?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
	selfieAndOfficialIdMatch?: Maybe<Scalars['Boolean']['output']>;
	selfieFaceRecognition?: Maybe<FaceRecognitionAnalysis>;
	warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ApproveRegistryInput = {
	clientId: Scalars['UUID7']['input'];
	deliberation: Scalars['String']['input'];
};

export type ApproveRegistryPayload = {
	__typename?: 'ApproveRegistryPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export enum BirthInformationCorrectableField {
	DATE_OF_BIRTH = 'DATE_OF_BIRTH'
}

/** Contract types for credit bureau reports */
export enum ContractType {
	AGRICULTURAL = 'AGRICULTURAL',
	AUTO_LEASE = 'AUTO_LEASE',
	AUTO_PURCHASE = 'AUTO_PURCHASE',
	AVIATION = 'AVIATION',
	BOAT = 'BOAT',
	BOND = 'BOND',
	BUSINESS_ACTIVITY_LOAN = 'BUSINESS_ACTIVITY_LOAN',
	BUSINESS_CREDIT_CARD = 'BUSINESS_CREDIT_CARD',
	COLLATERAL = 'COLLATERAL',
	CONSOLIDATION = 'CONSOLIDATION',
	CREDIT_CARD = 'CREDIT_CARD',
	CREDIT_LINE = 'CREDIT_LINE',
	DISCOUNTS = 'DISCOUNTS',
	EQUIPMENT_LOAN = 'EQUIPMENT_LOAN',
	EQUIPMENT_TRUST = 'EQUIPMENT_TRUST',
	FACTORING = 'FACTORING',
	FURNITURE_APPLIANCES = 'FURNITURE_APPLIANCES',
	HOME_EQUITY = 'HOME_EQUITY',
	HOME_IMPROVEMENT = 'HOME_IMPROVEMENT',
	INDUSTRIAL_UNITS_GUARANTEE = 'INDUSTRIAL_UNITS_GUARANTEE',
	INSURANCE = 'INSURANCE',
	LEASE = 'LEASE',
	LETTER_OF_CREDIT = 'LETTER_OF_CREDIT',
	OTHER = 'OTHER',
	OTHER_OVERDUE_DEBT = 'OTHER_OVERDUE_DEBT',
	OUTFITTING_CREDIT = 'OUTFITTING_CREDIT',
	PAYROLL_LOAN = 'PAYROLL_LOAN',
	PERSONAL_LOAN = 'PERSONAL_LOAN',
	PLEDGE_LOAN = 'PLEDGE_LOAN',
	PUBLISHING = 'PUBLISHING',
	REAL_ESTATE = 'REAL_ESTATE',
	RECREATIONAL_VEHICLE = 'RECREATIONAL_VEHICLE',
	REDISCOUNT = 'REDISCOUNT',
	RENEWED = 'RENEWED',
	RESTRUCTURED = 'RESTRUCTURED',
	REVOLVING_CREDIT_LINE = 'REVOLVING_CREDIT_LINE',
	SECOND_MORTGAGE = 'SECOND_MORTGAGE',
	SECURED_CARD = 'SECURED_CARD',
	SECURED_LOAN = 'SECURED_LOAN',
	SERVICES_PAYMENT = 'SERVICES_PAYMENT',
	SIMPLE_CREDIT = 'SIMPLE_CREDIT',
	STUDENT_LOAN = 'STUDENT_LOAN',
	TAX_CREDIT = 'TAX_CREDIT',
	UNKNOWN = 'UNKNOWN',
	UNSECURED_LOAN = 'UNSECURED_LOAN'
}

/** Country in ISO 3166-1 alpha-3 format */
export enum Country {
	ABW = 'ABW',
	AFG = 'AFG',
	AGO = 'AGO',
	AIA = 'AIA',
	ALA = 'ALA',
	ALB = 'ALB',
	AND = 'AND',
	ANT = 'ANT',
	ARE = 'ARE',
	ARG = 'ARG',
	ARM = 'ARM',
	ASM = 'ASM',
	ATA = 'ATA',
	ATF = 'ATF',
	ATG = 'ATG',
	AUS = 'AUS',
	AUT = 'AUT',
	AZE = 'AZE',
	BDI = 'BDI',
	BEL = 'BEL',
	BEN = 'BEN',
	BES = 'BES',
	BFA = 'BFA',
	BGD = 'BGD',
	BGR = 'BGR',
	BHR = 'BHR',
	BHS = 'BHS',
	BIH = 'BIH',
	BLM = 'BLM',
	BLR = 'BLR',
	BLZ = 'BLZ',
	BMU = 'BMU',
	BOL = 'BOL',
	BRA = 'BRA',
	BRB = 'BRB',
	BRN = 'BRN',
	BTN = 'BTN',
	BVT = 'BVT',
	BWA = 'BWA',
	CAF = 'CAF',
	CAN = 'CAN',
	CCK = 'CCK',
	CHE = 'CHE',
	CHL = 'CHL',
	CHN = 'CHN',
	CIV = 'CIV',
	CMR = 'CMR',
	COD = 'COD',
	COG = 'COG',
	COK = 'COK',
	COL = 'COL',
	COM = 'COM',
	CPV = 'CPV',
	CRI = 'CRI',
	CUB = 'CUB',
	CUW = 'CUW',
	CXR = 'CXR',
	CYM = 'CYM',
	CYP = 'CYP',
	CZE = 'CZE',
	DEU = 'DEU',
	DJI = 'DJI',
	DMA = 'DMA',
	DNK = 'DNK',
	DOM = 'DOM',
	DZA = 'DZA',
	ECU = 'ECU',
	EGY = 'EGY',
	ERI = 'ERI',
	ESH = 'ESH',
	ESP = 'ESP',
	EST = 'EST',
	ETH = 'ETH',
	FIN = 'FIN',
	FJI = 'FJI',
	FLK = 'FLK',
	FRA = 'FRA',
	FRO = 'FRO',
	FSM = 'FSM',
	GAB = 'GAB',
	GBR = 'GBR',
	GEO = 'GEO',
	GGY = 'GGY',
	GHA = 'GHA',
	GIB = 'GIB',
	GIN = 'GIN',
	GLP = 'GLP',
	GMB = 'GMB',
	GNB = 'GNB',
	GNQ = 'GNQ',
	GRC = 'GRC',
	GRD = 'GRD',
	GRL = 'GRL',
	GTM = 'GTM',
	GUF = 'GUF',
	GUM = 'GUM',
	GUY = 'GUY',
	HKG = 'HKG',
	HMD = 'HMD',
	HND = 'HND',
	HRV = 'HRV',
	HTI = 'HTI',
	HUN = 'HUN',
	IDN = 'IDN',
	IMN = 'IMN',
	IND = 'IND',
	IOT = 'IOT',
	IRL = 'IRL',
	IRN = 'IRN',
	IRQ = 'IRQ',
	ISL = 'ISL',
	ISR = 'ISR',
	ITA = 'ITA',
	JAM = 'JAM',
	JEY = 'JEY',
	JOR = 'JOR',
	JPN = 'JPN',
	KAZ = 'KAZ',
	KEN = 'KEN',
	KGZ = 'KGZ',
	KHM = 'KHM',
	KIR = 'KIR',
	KNA = 'KNA',
	KOR = 'KOR',
	KWT = 'KWT',
	LAO = 'LAO',
	LBN = 'LBN',
	LBR = 'LBR',
	LBY = 'LBY',
	LCA = 'LCA',
	LIE = 'LIE',
	LKA = 'LKA',
	LSO = 'LSO',
	LTU = 'LTU',
	LUX = 'LUX',
	LVA = 'LVA',
	MAC = 'MAC',
	MAF = 'MAF',
	MAR = 'MAR',
	MCO = 'MCO',
	MDA = 'MDA',
	MDG = 'MDG',
	MDV = 'MDV',
	MEX = 'MEX',
	MHL = 'MHL',
	MKD = 'MKD',
	MLI = 'MLI',
	MLT = 'MLT',
	MMR = 'MMR',
	MNE = 'MNE',
	MNG = 'MNG',
	MNP = 'MNP',
	MOZ = 'MOZ',
	MRT = 'MRT',
	MSR = 'MSR',
	MTQ = 'MTQ',
	MUS = 'MUS',
	MWI = 'MWI',
	MYS = 'MYS',
	MYT = 'MYT',
	NAM = 'NAM',
	NCL = 'NCL',
	NER = 'NER',
	NFK = 'NFK',
	NGA = 'NGA',
	NIC = 'NIC',
	NIU = 'NIU',
	NLD = 'NLD',
	NOR = 'NOR',
	NPL = 'NPL',
	NRU = 'NRU',
	NZL = 'NZL',
	OMN = 'OMN',
	PAK = 'PAK',
	PAN = 'PAN',
	PCN = 'PCN',
	PER = 'PER',
	PHL = 'PHL',
	PLW = 'PLW',
	PNG = 'PNG',
	POL = 'POL',
	PRI = 'PRI',
	PRK = 'PRK',
	PRT = 'PRT',
	PRY = 'PRY',
	PSE = 'PSE',
	PYF = 'PYF',
	QAT = 'QAT',
	REU = 'REU',
	ROU = 'ROU',
	RUS = 'RUS',
	RWA = 'RWA',
	SAU = 'SAU',
	SDN = 'SDN',
	SEN = 'SEN',
	SGP = 'SGP',
	SGS = 'SGS',
	SHN = 'SHN',
	SJM = 'SJM',
	SLB = 'SLB',
	SLE = 'SLE',
	SLV = 'SLV',
	SMR = 'SMR',
	SOM = 'SOM',
	SPM = 'SPM',
	SRB = 'SRB',
	SSD = 'SSD',
	STP = 'STP',
	SUR = 'SUR',
	SVK = 'SVK',
	SVN = 'SVN',
	SWE = 'SWE',
	SWZ = 'SWZ',
	SXM = 'SXM',
	SYC = 'SYC',
	SYR = 'SYR',
	TCA = 'TCA',
	TCD = 'TCD',
	TGO = 'TGO',
	THA = 'THA',
	TJK = 'TJK',
	TKL = 'TKL',
	TKM = 'TKM',
	TLS = 'TLS',
	TON = 'TON',
	TTO = 'TTO',
	TUN = 'TUN',
	TUR = 'TUR',
	TUV = 'TUV',
	TWN = 'TWN',
	TZA = 'TZA',
	UGA = 'UGA',
	UKR = 'UKR',
	UMI = 'UMI',
	URY = 'URY',
	USA = 'USA',
	UZB = 'UZB',
	VAT = 'VAT',
	VCT = 'VCT',
	VEN = 'VEN',
	VGB = 'VGB',
	VIR = 'VIR',
	VNM = 'VNM',
	VUT = 'VUT',
	WLF = 'WLF',
	WSM = 'WSM',
	YEM = 'YEM',
	ZAF = 'ZAF',
	ZMB = 'ZMB',
	ZWE = 'ZWE'
}

export type CreditBureauAccount = {
	__typename?: 'CreditBureauAccount';
	accountClosingDate?: Maybe<Scalars['String']['output']>;
	accountOpeningDate?: Maybe<Scalars['String']['output']>;
	accountType?: Maybe<AccountType>;
	assetValuationValue?: Maybe<Scalars['String']['output']>;
	collateral?: Maybe<Scalars['String']['output']>;
	contractType?: Maybe<ContractType>;
	creditIdentifier?: Maybe<Scalars['String']['output']>;
	creditInfoSocietyIdentifier?: Maybe<Scalars['String']['output']>;
	creditLimit?: Maybe<Scalars['String']['output']>;
	currencyCode?: Maybe<Scalars['String']['output']>;
	currentAccountNumber?: Maybe<Scalars['String']['output']>;
	currentBalance?: Maybe<Scalars['String']['output']>;
	disputedRecord?: Maybe<Scalars['Boolean']['output']>;
	emailAddress?: Maybe<Scalars['String']['output']>;
	grantorCode?: Maybe<Scalars['String']['output']>;
	grantorName?: Maybe<Scalars['String']['output']>;
	grantorPhoneNumber?: Maybe<Scalars['String']['output']>;
	highestDelinquencyAmount?: Maybe<Scalars['String']['output']>;
	lastPaymentAmount?: Maybe<Scalars['String']['output']>;
	lastPaymentDate?: Maybe<Scalars['String']['output']>;
	lastPurchaseDate?: Maybe<Scalars['String']['output']>;
	lastZeroBalanceDate?: Maybe<Scalars['String']['output']>;
	maximumCredit?: Maybe<Scalars['String']['output']>;
	numberOfOverduePayments?: Maybe<Scalars['String']['output']>;
	numberOfPayments?: Maybe<Scalars['String']['output']>;
	observationCode?: Maybe<Scalars['String']['output']>;
	overdueBalance?: Maybe<Scalars['String']['output']>;
	paymentAmount?: Maybe<Scalars['String']['output']>;
	paymentFrequency?: Maybe<PaymentFrequency>;
	paymentHistory?: Maybe<Scalars['String']['output']>;
	paymentHistoryEndDate?: Maybe<Scalars['String']['output']>;
	paymentHistoryStartDate?: Maybe<Scalars['String']['output']>;
	paymentStatus?: Maybe<Scalars['String']['output']>;
	payments1Or29DaysLate?: Maybe<Scalars['String']['output']>;
	payments30Or59DaysLate?: Maybe<Scalars['String']['output']>;
	payments60Or89DaysLate?: Maybe<Scalars['String']['output']>;
	payments90Or119DaysLate?: Maybe<Scalars['String']['output']>;
	payrollCreditCancelDate?: Maybe<Scalars['String']['output']>;
	payrollCreditHistory?: Maybe<Scalars['String']['output']>;
	payrollCreditHistoryEndDate?: Maybe<Scalars['String']['output']>;
	payrollCreditHistoryStartDate?: Maybe<Scalars['String']['output']>;
	payrollCreditIdentifier?: Maybe<Scalars['String']['output']>;
	payrollCreditOpenDate?: Maybe<Scalars['String']['output']>;
	reportDate?: Maybe<Scalars['String']['output']>;
	reportingMethod?: Maybe<Scalars['String']['output']>;
	responsibilityType?: Maybe<ResponsibilityType>;
	restructuringStartDate?: Maybe<Scalars['String']['output']>;
	totalReportedPayments?: Maybe<Scalars['String']['output']>;
	updateDate?: Maybe<Scalars['String']['output']>;
	worstDelinquencyDate?: Maybe<Scalars['String']['output']>;
	worstPaymentStatus?: Maybe<Scalars['String']['output']>;
};

export type CreditBureauAddress = {
	__typename?: 'CreditBureauAddress';
	addressLine1?: Maybe<Scalars['String']['output']>;
	addressLine2?: Maybe<Scalars['String']['output']>;
	addressReportDate?: Maybe<Scalars['String']['output']>;
	addressType?: Maybe<AddressType>;
	countryCode?: Maybe<Scalars['String']['output']>;
	extension?: Maybe<Scalars['String']['output']>;
	fax?: Maybe<Scalars['String']['output']>;
	municipalityDelegation?: Maybe<Scalars['String']['output']>;
	neighborhood?: Maybe<Scalars['String']['output']>;
	phoneNumber?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	residenceDate?: Maybe<Scalars['String']['output']>;
	specialAddressIndicator?: Maybe<SpecialAddressIndicator>;
	stateCode?: Maybe<MexState>;
};

/** Credit Bureau Authorization */
export type CreditBureauAuthorization = Node & {
	__typename?: 'CreditBureauAuthorization';
	creditBureauReportRequestId?: Maybe<Scalars['String']['output']>;
	fullName?: Maybe<Scalars['String']['output']>;
	/** The ID of an object */
	id: Scalars['ID']['output'];
	officialAddress?: Maybe<OfficialAddress>;
	requestDate?: Maybe<Scalars['String']['output']>;
	requestId?: Maybe<Scalars['String']['output']>;
	rfc?: Maybe<Scalars['String']['output']>;
	successful?: Maybe<Scalars['Boolean']['output']>;
	wasAuthorized?: Maybe<Scalars['Boolean']['output']>;
	wasNipRequested?: Maybe<Scalars['Boolean']['output']>;
};

export type CreditBureauAuthorizationConnection = {
	__typename?: 'CreditBureauAuthorizationConnection';
	count?: Maybe<Scalars['Int']['output']>;
	edges?: Maybe<Array<Maybe<CreditBureauAuthorizationEdge>>>;
	pageInfo: PageInfo;
};

export type CreditBureauAuthorizationConnectionCountArgs = {
	filter?: InputMaybe<CreditBureauAuthorizationFilter>;
};

export type CreditBureauAuthorizationEdge = {
	__typename?: 'CreditBureauAuthorizationEdge';
	cursor?: Maybe<Scalars['String']['output']>;
	node?: Maybe<CreditBureauAuthorization>;
};

export type CreditBureauAuthorizationFilter = {
	requestDate?: InputMaybe<DatetimeRange>;
};

export type CreditBureauAuthorizationSort = {
	requestDate?: InputMaybe<SortDirection>;
};

export type CreditBureauCreditInquiry = {
	__typename?: 'CreditBureauCreditInquiry';
	contractAmount?: Maybe<Scalars['String']['output']>;
	contractType?: Maybe<ContractType>;
	grantorCode?: Maybe<Scalars['String']['output']>;
	grantorName?: Maybe<Scalars['String']['output']>;
	inquiryDate?: Maybe<Scalars['String']['output']>;
	inquiryOriginIdentifier?: Maybe<InquiryOriginIdentifier>;
	isNewConsumer?: Maybe<Scalars['Boolean']['output']>;
	responsibilityType?: Maybe<ResponsibilityType>;
};

export type CreditBureauCreditScore = {
	__typename?: 'CreditBureauCreditScore';
	reasonCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	scoreCode?: Maybe<Scalars['String']['output']>;
	scoreName?: Maybe<Scalars['String']['output']>;
	scoreValue?: Maybe<Scalars['String']['output']>;
};

export type CreditBureauEmployment = {
	__typename?: 'CreditBureauEmployment';
	addressLine1?: Maybe<Scalars['String']['output']>;
	addressLine2?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	companyName?: Maybe<Scalars['String']['output']>;
	countryCode?: Maybe<Scalars['String']['output']>;
	disputedRecord?: Maybe<Scalars['Boolean']['output']>;
	employeeNumber?: Maybe<Scalars['String']['output']>;
	employmentReportDate?: Maybe<Scalars['String']['output']>;
	extension?: Maybe<Scalars['String']['output']>;
	fax?: Maybe<Scalars['String']['output']>;
	hireDate?: Maybe<Scalars['String']['output']>;
	jobTitle?: Maybe<Scalars['String']['output']>;
	lastEmploymentDate?: Maybe<Scalars['String']['output']>;
	municipalityDelegation?: Maybe<Scalars['String']['output']>;
	neighborhood?: Maybe<Scalars['String']['output']>;
	phoneNumber?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	salary?: Maybe<Scalars['String']['output']>;
	salaryBasis?: Maybe<Scalars['String']['output']>;
	stateCode?: Maybe<MexState>;
	verificationDate?: Maybe<Scalars['String']['output']>;
	verificationMethod?: Maybe<VerificationMethod>;
};

export type CreditBureauHeader = {
	__typename?: 'CreditBureauHeader';
	bureauIdentifier?: Maybe<Scalars['String']['output']>;
	countryCode?: Maybe<Scalars['String']['output']>;
	grantorCode?: Maybe<Scalars['String']['output']>;
	inquiryControlNumber?: Maybe<Scalars['String']['output']>;
	operatorReferenceNumber?: Maybe<Scalars['String']['output']>;
	primaryConsumerReturnCode?: Maybe<Scalars['String']['output']>;
	secondaryConsumerReturnCode?: Maybe<Scalars['String']['output']>;
	version?: Maybe<Scalars['String']['output']>;
};

export enum CreditBureauMaritalStatus {
	DIVORCED = 'DIVORCED',
	DOMESTIC_PARTNERSHIP = 'DOMESTIC_PARTNERSHIP',
	MARRIED = 'MARRIED',
	SINGLE = 'SINGLE',
	WIDOWED = 'WIDOWED'
}

export type CreditBureauPerson = {
	__typename?: 'CreditBureauPerson';
	additionalLastName?: Maybe<Scalars['String']['output']>;
	agesOfDependents?: Maybe<Scalars['String']['output']>;
	dateOfBirth?: Maybe<Scalars['String']['output']>;
	dateOfDeath?: Maybe<Scalars['String']['output']>;
	dependentInformationReceiptDate?: Maybe<Scalars['String']['output']>;
	driversLicenseNumber?: Maybe<Scalars['String']['output']>;
	firstLastName?: Maybe<Scalars['String']['output']>;
	firstName?: Maybe<Scalars['String']['output']>;
	foreignCountryCode?: Maybe<Scalars['String']['output']>;
	foreignTaxCode?: Maybe<Scalars['String']['output']>;
	gender?: Maybe<Scalars['String']['output']>;
	maritalStatus?: Maybe<CreditBureauMaritalStatus>;
	middleName?: Maybe<Scalars['String']['output']>;
	namePrefix?: Maybe<Scalars['String']['output']>;
	nameSuffix?: Maybe<Scalars['String']['output']>;
	nationality?: Maybe<Scalars['String']['output']>;
	numberOfDependents?: Maybe<Scalars['String']['output']>;
	professionalLicenseNumber?: Maybe<Scalars['String']['output']>;
	residenceType?: Maybe<ResidenceType>;
	rfc?: Maybe<Scalars['String']['output']>;
	secondLastName?: Maybe<Scalars['String']['output']>;
	voterRegistrationNumber?: Maybe<Scalars['String']['output']>;
};

/** Credit Bureau Report */
export type CreditBureauReport = {
	__typename?: 'CreditBureauReport';
	accounts?: Maybe<Array<Maybe<CreditBureauAccount>>>;
	addresses?: Maybe<Array<Maybe<CreditBureauAddress>>>;
	creditInquiries?: Maybe<Array<Maybe<CreditBureauCreditInquiry>>>;
	creditScores?: Maybe<Array<Maybe<CreditBureauCreditScore>>>;
	employments?: Maybe<Array<Maybe<CreditBureauEmployment>>>;
	hawkAlertConsulta?: Maybe<Array<Maybe<HawkAlert>>>;
	hawkAlertDb?: Maybe<Array<Maybe<HawkAlert>>>;
	header?: Maybe<CreditBureauHeader>;
	person?: Maybe<CreditBureauPerson>;
	ratingAi?: Maybe<Scalars['String']['output']>;
	summary?: Maybe<CreditBureauSummary>;
};

export type CreditBureauSummary = {
	__typename?: 'CreditBureauSummary';
	accountsCurrent?: Maybe<Scalars['String']['output']>;
	accountsWith1Or29DaysLatePayment?: Maybe<Scalars['String']['output']>;
	accountsWith30Or59DaysLatePayment?: Maybe<Scalars['String']['output']>;
	accountsWith60Or89DaysLatePayment?: Maybe<Scalars['String']['output']>;
	accountsWith90Or119DaysLatePayment?: Maybe<Scalars['String']['output']>;
	accountsWith120To149DaysLatePayment?: Maybe<Scalars['String']['output']>;
	accountsWith150To365DaysLatePayment?: Maybe<Scalars['String']['output']>;
	accountsWith365PlusDaysLatePayment?: Maybe<Scalars['String']['output']>;
	accountsWithCommitedFraud?: Maybe<Scalars['String']['output']>;
	accountsWithNegativeHistory?: Maybe<Scalars['String']['output']>;
	alertMessages?: Maybe<Scalars['String']['output']>;
	closedAccounts?: Maybe<Scalars['String']['output']>;
	consumerStatementsExistence?: Maybe<Scalars['Boolean']['output']>;
	currentNegativeAccounts?: Maybe<Scalars['String']['output']>;
	databaseEntryDate?: Maybe<Scalars['String']['output']>;
	disputedAccounts?: Maybe<Scalars['String']['output']>;
	fixedPaymentMortgageAccounts?: Maybe<Scalars['String']['output']>;
	mostRecentAccountOpeningDate?: Maybe<Scalars['String']['output']>;
	mostRecentCollectionAgencyAccountOpeningDate?: Maybe<Scalars['String']['output']>;
	mostRecentCollectionAgencyRequestDate?: Maybe<Scalars['String']['output']>;
	mostRecentReportRequestDate?: Maybe<Scalars['String']['output']>;
	newAddressReportedLast60Days?: Maybe<Scalars['Boolean']['output']>;
	numberOfAccounts?: Maybe<Scalars['String']['output']>;
	numberOfAccountsWithoutLatePayments?: Maybe<Scalars['String']['output']>;
	numberOfInquiriesLast6Months?: Maybe<Scalars['String']['output']>;
	numberOfRecentAccountsWithoutClassification?: Maybe<Scalars['String']['output']>;
	oldestAccountOpeningDate?: Maybe<Scalars['String']['output']>;
	openRevolvingAccounts?: Maybe<Scalars['String']['output']>;
	revolvingCreditUtilizationPercentage?: Maybe<Scalars['String']['output']>;
	totalCollectionAgenciesRequests?: Maybe<Scalars['String']['output']>;
	totalFixedPaymentCurrentBalances?: Maybe<Scalars['String']['output']>;
	totalFixedPayments?: Maybe<Scalars['String']['output']>;
	totalReportRequests?: Maybe<Scalars['String']['output']>;
	totalRevolvingCurrentBalances?: Maybe<Scalars['String']['output']>;
	totalRevolvingMaximumCredits?: Maybe<Scalars['String']['output']>;
	totalRevolvingOverdueBalances?: Maybe<Scalars['String']['output']>;
	totalRevolvingPayments?: Maybe<Scalars['String']['output']>;
};

export type CreditSummaryBureauReport = {
	__typename?: 'CreditSummaryBureauReport';
	accounts?: Maybe<Array<Maybe<CreditSummaryBureauReportAccounts>>>;
	lastSixMonthsInquiries?: Maybe<Scalars['Int']['output']>;
	monthsOverdue?: Maybe<Scalars['Int']['output']>;
	totalTrials?: Maybe<Scalars['Int']['output']>;
	trials?: Maybe<Array<Maybe<TrialType>>>;
	utilizationPostPandemic?: Maybe<Scalars['Decimal']['output']>;
	utilizationPrePandemic?: Maybe<Scalars['Decimal']['output']>;
	yearsInCreditBureau?: Maybe<Scalars['Int']['output']>;
};

export type CreditSummaryBureauReportAccounts = {
	__typename?: 'CreditSummaryBureauReportAccounts';
	closedAccounts?: Maybe<CreditSummaryBureauReportClosedAccounts>;
	openAccounts?: Maybe<CreditSummaryBureauReportOpenAccounts>;
	paymentStatus?: Maybe<PaymentStatus>;
};

export type CreditSummaryBureauReportClosedAccounts = {
	__typename?: 'CreditSummaryBureauReportClosedAccounts';
	amount?: Maybe<Scalars['Money']['output']>;
	currentBalance?: Maybe<Scalars['Money']['output']>;
	limitBalance?: Maybe<Scalars['Money']['output']>;
	maximumBalance?: Maybe<Scalars['Money']['output']>;
	monthlyPayment?: Maybe<Scalars['Money']['output']>;
	numberOfAccounts?: Maybe<Scalars['Int']['output']>;
};

export type CreditSummaryBureauReportOpenAccounts = {
	__typename?: 'CreditSummaryBureauReportOpenAccounts';
	amount?: Maybe<Scalars['Money']['output']>;
	currentBalance?: Maybe<Scalars['Money']['output']>;
	limitBalance?: Maybe<Scalars['Money']['output']>;
	maximumBalance?: Maybe<Scalars['Money']['output']>;
	monthlyPayment?: Maybe<Scalars['Money']['output']>;
	numberOfAccounts?: Maybe<Scalars['Int']['output']>;
};

export type CurpAnalysis = {
	__typename?: 'CurpAnalysis';
	curp?: Maybe<Scalars['String']['output']>;
	dateOfBirth?: Maybe<Scalars['String']['output']>;
	error?: Maybe<Scalars['String']['output']>;
	gender?: Maybe<Scalars['String']['output']>;
	governmentName?: Maybe<Scalars['String']['output']>;
	isMexican?: Maybe<Scalars['Boolean']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type DatetimeRange = {
	from?: InputMaybe<Scalars['DateTime']['input']>;
	to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DownloadRegistryDocumentsInput = {
	clientId: Scalars['UUID7']['input'];
};

export type DownloadRegistryDocumentsPayload = {
	__typename?: 'DownloadRegistryDocumentsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	result?: Maybe<RegistryDocuments>;
	successful: Scalars['Boolean']['output'];
};

export type EmailAnalysis = {
	__typename?: 'EmailAnalysis';
	deliverability?: Maybe<Scalars['String']['output']>;
	fraudScore?: Maybe<Scalars['Int']['output']>;
	hasRecentAbuseInTrullyNetwork?: Maybe<Scalars['Boolean']['output']>;
	isDisposable?: Maybe<Scalars['Boolean']['output']>;
	isFrequentComplainer?: Maybe<Scalars['Boolean']['output']>;
	isLeaked?: Maybe<Scalars['Boolean']['output']>;
	isSpamHoneypot?: Maybe<Scalars['Boolean']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
	sanitizedEmail?: Maybe<Scalars['String']['output']>;
	spamTrapScore?: Maybe<Scalars['String']['output']>;
};

export type FaceRecognitionAnalysis = {
	__typename?: 'FaceRecognitionAnalysis';
	companiesSeen?: Maybe<Scalars['Int']['output']>;
	confidenceScore?: Maybe<Scalars['Decimal']['output']>;
	gender?: Maybe<Scalars['String']['output']>;
	isMarkedAsFraudInTrullyNetwork?: Maybe<Scalars['Boolean']['output']>;
	lastSeenInTrullyNetwork?: Maybe<Scalars['String']['output']>;
	timesSeenLastMonthInTrullyNetwork?: Maybe<Scalars['Int']['output']>;
	warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HawkAlert = {
	__typename?: 'HawkAlert';
	institutionType?: Maybe<Scalars['String']['output']>;
	keyCode?: Maybe<Scalars['String']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	reportDate?: Maybe<Scalars['String']['output']>;
	typeOfJury?: Maybe<JuryType>;
	typeOfTrial?: Maybe<TrialType>;
};

export type IneAnalysis = {
	__typename?: 'IneAnalysis';
	curp?: Maybe<Scalars['String']['output']>;
	electoralKey?: Maybe<Scalars['String']['output']>;
	firstLastName?: Maybe<Scalars['String']['output']>;
	names?: Maybe<Scalars['String']['output']>;
	secondLastName?: Maybe<Scalars['String']['output']>;
	validThru?: Maybe<Scalars['String']['output']>;
};

export enum InquiryOriginIdentifier {
	CIRCLE_OF_CREDIT = 'CIRCLE_OF_CREDIT',
	CREDIT_BUREAU = 'CREDIT_BUREAU'
}

/** The action was not allowed for a given reason. */
export type InvalidAction = {
	__typename?: 'InvalidAction';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

/** Provided input is not valid. */
export type InvalidInput = {
	__typename?: 'InvalidInput';
	/** Validation context. */
	context: Array<Maybe<InvalidInputContext>>;
	/** Invalid input field's name. */
	field: Scalars['String']['output'];
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

/** Parameter taken into consideration for the validation. */
export type InvalidInputContext = {
	__typename?: 'InvalidInputContext';
	key: Scalars['String']['output'];
	value?: Maybe<Scalars['String']['output']>;
};

export type IpAddressAnalysis = {
	__typename?: 'IpAddressAnalysis';
	blacklistedCount?: Maybe<Scalars['Int']['output']>;
	isBlacklisted?: Maybe<Scalars['Boolean']['output']>;
	isTorConnection?: Maybe<Scalars['Boolean']['output']>;
	isVpnConnection?: Maybe<Scalars['Boolean']['output']>;
};

export enum JuryType {
	AMPARO_TRIAL = 'AMPARO_TRIAL',
	CIVIL_COMMERCIAL_OR_FAMILY_CO_DEFENDANT = 'CIVIL_COMMERCIAL_OR_FAMILY_CO_DEFENDANT',
	CIVIL_COMMERCIAL_OR_FAMILY_DEFENDANT = 'CIVIL_COMMERCIAL_OR_FAMILY_DEFENDANT',
	CRIMINAL_TRIAL = 'CRIMINAL_TRIAL',
	NOT_APPLICABLE = 'NOT_APPLICABLE'
}

export type LocationAndAddressDistanceAnalysis = {
	__typename?: 'LocationAndAddressDistanceAnalysis';
	level?: Maybe<Scalars['String']['output']>;
	observation?: Maybe<Scalars['String']['output']>;
};

export enum MaritalStatus {
	DIVORCED = 'DIVORCED',
	FREE_UNION = 'FREE_UNION',
	MARRIED_JOINT_PROPERTY = 'MARRIED_JOINT_PROPERTY',
	MARRIED_SEPARATED_PROPERTY = 'MARRIED_SEPARATED_PROPERTY',
	SEPARATED = 'SEPARATED',
	SINGLE = 'SINGLE',
	WIDOWED = 'WIDOWED'
}

/** Mexico's state in ISO 3166-1 alpha-3 format */
export enum MexState {
	AGU = 'AGU',
	BCN = 'BCN',
	BCS = 'BCS',
	CAM = 'CAM',
	CHH = 'CHH',
	CHP = 'CHP',
	CMX = 'CMX',
	COA = 'COA',
	COL = 'COL',
	DUR = 'DUR',
	GRO = 'GRO',
	GUA = 'GUA',
	HID = 'HID',
	JAL = 'JAL',
	MEX = 'MEX',
	MIC = 'MIC',
	MOR = 'MOR',
	NAY = 'NAY',
	NLE = 'NLE',
	OAX = 'OAX',
	PUE = 'PUE',
	QUE = 'QUE',
	ROO = 'ROO',
	SIN = 'SIN',
	SLP = 'SLP',
	SON = 'SON',
	TAB = 'TAB',
	TAM = 'TAM',
	TLA = 'TLA',
	VER = 'VER',
	YUC = 'YUC',
	ZAC = 'ZAC'
}

export type ModifyDeliberationInput = {
	clientId: Scalars['UUID7']['input'];
	deliberation: Scalars['String']['input'];
};

export type ModifyDeliberationPayload = {
	__typename?: 'ModifyDeliberationPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

/** Common errors for any mutation. */
export type MutationError = ActionFailed | InvalidAction | InvalidInput;

export type Node = {
	/** The ID of the object. */
	id: Scalars['ID']['output'];
};

export type OfficialAddress = {
	__typename?: 'OfficialAddress';
	city?: Maybe<Scalars['String']['output']>;
	colony?: Maybe<Scalars['String']['output']>;
	externalNumber?: Maybe<Scalars['String']['output']>;
	internalNumber?: Maybe<Scalars['String']['output']>;
	municipalityOrDelegation?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	state?: Maybe<Scalars['String']['output']>;
	street?: Maybe<Scalars['String']['output']>;
};

export enum OfficialAddressCorrectableField {
	CITY = 'CITY',
	POSTAL_CODE = 'POSTAL_CODE',
	PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
	STATE = 'STATE'
}

/** High level progress of the onboarding's registry */
export enum OnboardingStatus {
	APPROVED = 'APPROVED',
	CORRECTIONS_REQUESTED = 'CORRECTIONS_REQUESTED',
	/** Registry's information has not been completely filled */
	IN_PROCESS = 'IN_PROCESS',
	PENDING_REVIEW = 'PENDING_REVIEW',
	REJECTED = 'REJECTED'
}

export type PageInfo = {
	__typename?: 'PageInfo';
	/** When paginating forwards, the cursor to continue. */
	endCursor?: Maybe<Scalars['String']['output']>;
	/** When paginating forwards, are there more items? */
	hasNextPage: Scalars['Boolean']['output'];
	/** When paginating backwards, are there more items? */
	hasPreviousPage: Scalars['Boolean']['output'];
	/** When paginating backwards, the cursor to continue. */
	startCursor?: Maybe<Scalars['String']['output']>;
};

export type PassportAnalysis = {
	__typename?: 'PassportAnalysis';
	citizenship?: Maybe<Scalars['String']['output']>;
	curp?: Maybe<Scalars['String']['output']>;
	dateOfBirth?: Maybe<Scalars['String']['output']>;
	expirationDate?: Maybe<Scalars['String']['output']>;
	lastNames?: Maybe<Scalars['String']['output']>;
	names?: Maybe<Scalars['String']['output']>;
	passportNumber?: Maybe<Scalars['String']['output']>;
};

export enum PaymentFrequency {
	ANNUALLY = 'ANNUALLY',
	BIMONTHLY = 'BIMONTHLY',
	BIWEEKLY = 'BIWEEKLY',
	DAILY = 'DAILY',
	MINIMUM_PAYMENT = 'MINIMUM_PAYMENT',
	MONTHLY = 'MONTHLY',
	QUARTERLY = 'QUARTERLY',
	SALARY_DEDUCTION = 'SALARY_DEDUCTION',
	SEMI_ANNUALLY = 'SEMI_ANNUALLY',
	SEMI_MONTHLY = 'SEMI_MONTHLY',
	VARIABLE = 'VARIABLE',
	WEEKLY = 'WEEKLY'
}

export enum PaymentStatus {
	CODE_00 = 'CODE_00',
	CODE_01 = 'CODE_01',
	CODE_02 = 'CODE_02',
	CODE_03 = 'CODE_03',
	CODE_04 = 'CODE_04',
	CODE_05 = 'CODE_05',
	CODE_06 = 'CODE_06',
	CODE_07 = 'CODE_07',
	CODE_96 = 'CODE_96',
	CODE_97 = 'CODE_97',
	CODE_99 = 'CODE_99',
	CODE_TOTAL = 'CODE_TOTAL',
	CODE_UR = 'CODE_UR'
}

export enum PersonalInformationCorrectableField {
	CURP = 'CURP',
	FIRST_LAST_NAME = 'FIRST_LAST_NAME',
	MARITAL_STATUS = 'MARITAL_STATUS',
	NAMES = 'NAMES',
	SECOND_LAST_NAME = 'SECOND_LAST_NAME'
}

export type PhoneNumberAnalysis = {
	__typename?: 'PhoneNumberAnalysis';
	carrier?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	fraudScore?: Maybe<Scalars['Int']['output']>;
	hasFraudulentBehavior?: Maybe<Scalars['Boolean']['output']>;
	hasRecentAbuseInTrullyNetwork?: Maybe<Scalars['Boolean']['output']>;
	isActive?: Maybe<Scalars['Boolean']['output']>;
	isDigitalPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
	isLeaked?: Maybe<Scalars['Boolean']['output']>;
	isSpammer?: Maybe<Scalars['Boolean']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
	onWhatsapp?: Maybe<Scalars['Boolean']['output']>;
};

export enum ProofOfLifeCorrectableField {
	INE_BACK = 'INE_BACK',
	INE_FRONT = 'INE_FRONT',
	SELFIE = 'SELFIE'
}

export type Registry = Node & {
	__typename?: 'Registry';
	antifraudAnalysis?: Maybe<AntifraudAnalysis>;
	birthInformation?: Maybe<RegistryBirthInformation>;
	clientId?: Maybe<Scalars['ID']['output']>;
	creditBureauDefaultScore?: Maybe<Scalars['Decimal']['output']>;
	creditBureauReport?: Maybe<CreditBureauReport>;
	creditSummaryBureauReport?: Maybe<CreditSummaryBureauReport>;
	deliberation?: Maybe<Scalars['String']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	/** The ID of an object */
	id: Scalars['ID']['output'];
	isCreditBureauApproved?: Maybe<Scalars['Boolean']['output']>;
	officialAddress?: Maybe<RegistryOfficialAddress>;
	onboardingChangesDescription?: Maybe<Scalars['String']['output']>;
	onboardingStatus?: Maybe<OnboardingStatus>;
	personalInformation?: Maybe<RegistryPersonalInformation>;
	phoneNumber?: Maybe<Scalars['String']['output']>;
	proofOfLife?: Maybe<RegistryProofOfLife>;
	registryStatus?: Maybe<RegistryStatus>;
	startedAt?: Maybe<Scalars['DateTime']['output']>;
	taxInformation?: Maybe<RegistryTaxInformation>;
	unicoAntifraudAnalysis?: Maybe<Scalars['Json']['output']>;
};

export type RegistryBirthInformation = {
	__typename?: 'RegistryBirthInformation';
	correctionsRequested?: Maybe<Array<Maybe<BirthInformationCorrectableField>>>;
	countryOfBirth?: Maybe<Country>;
	dateOfBirth?: Maybe<Scalars['Date']['output']>;
	mexStateOfBirth?: Maybe<MexState>;
};

export type RegistryConnection = {
	__typename?: 'RegistryConnection';
	count?: Maybe<Scalars['Int']['output']>;
	edges?: Maybe<Array<Maybe<RegistryEdge>>>;
	pageInfo: PageInfo;
};

export type RegistryConnectionCountArgs = {
	filter?: InputMaybe<RegistryFilter>;
};

export type RegistryDocuments = {
	__typename?: 'RegistryDocuments';
	ineBack?: Maybe<Scalars['String']['output']>;
	ineFront?: Maybe<Scalars['String']['output']>;
	proofOfAddress?: Maybe<Scalars['String']['output']>;
	selfie?: Maybe<Scalars['String']['output']>;
	taxStatusCertificate?: Maybe<Scalars['String']['output']>;
};

export type RegistryEdge = {
	__typename?: 'RegistryEdge';
	cursor?: Maybe<Scalars['String']['output']>;
	node?: Maybe<Registry>;
};

export type RegistryFilter = {
	onboardingStatus?: InputMaybe<Array<InputMaybe<OnboardingStatus>>>;
	searchTerm?: InputMaybe<Scalars['String']['input']>;
	startedAt?: InputMaybe<DatetimeRange>;
};

export type RegistryOfficialAddress = {
	__typename?: 'RegistryOfficialAddress';
	betweenStreetsOne?: Maybe<Scalars['String']['output']>;
	betweenStreetsTwo?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	colony?: Maybe<Scalars['String']['output']>;
	correctionsRequested?: Maybe<Array<Maybe<OfficialAddressCorrectableField>>>;
	externalNumber?: Maybe<Scalars['String']['output']>;
	internalNumber?: Maybe<Scalars['String']['output']>;
	municipalityOrDelegation?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	relationWithAddressHolder?: Maybe<RelationWithAddressHolder>;
	state?: Maybe<Scalars['String']['output']>;
	street?: Maybe<Scalars['String']['output']>;
};

export type RegistryPersonalInformation = {
	__typename?: 'RegistryPersonalInformation';
	correctionsRequested?: Maybe<Array<Maybe<PersonalInformationCorrectableField>>>;
	curp?: Maybe<Scalars['String']['output']>;
	facebookProfileUri?: Maybe<Scalars['String']['output']>;
	firstLastName?: Maybe<Scalars['String']['output']>;
	hasChildren?: Maybe<Scalars['Boolean']['output']>;
	maritalStatus?: Maybe<MaritalStatus>;
	names?: Maybe<Scalars['String']['output']>;
	secondLastName?: Maybe<Scalars['String']['output']>;
};

export type RegistryProofOfLife = {
	__typename?: 'RegistryProofOfLife';
	correctionsRequested?: Maybe<Array<Maybe<ProofOfLifeCorrectableField>>>;
	ipAddress?: Maybe<Scalars['String']['output']>;
	locationLatitude?: Maybe<Scalars['Decimal']['output']>;
	locationLongitude?: Maybe<Scalars['Decimal']['output']>;
};

export type RegistrySort = {
	onboardingStatus?: InputMaybe<SortDirection>;
	startedAt?: InputMaybe<SortDirection>;
};

/** The current status of the onboarding's registry */
export enum RegistryStatus {
	APPROVED = 'APPROVED',
	BIRTH_INFORMATION_REGISTERED = 'BIRTH_INFORMATION_REGISTERED',
	COMPLETED = 'COMPLETED',
	/** Email and phone number are verified */
	CONTACT_INFORMATION_REGISTERED = 'CONTACT_INFORMATION_REGISTERED',
	CORRECTIONS_REQUESTED = 'CORRECTIONS_REQUESTED',
	OFFICIAL_ADDRESS_REGISTERED = 'OFFICIAL_ADDRESS_REGISTERED',
	PERSONAL_INFORMATION_REGISTERED = 'PERSONAL_INFORMATION_REGISTERED',
	PROOF_OF_LIFE_REGISTERED = 'PROOF_OF_LIFE_REGISTERED',
	REJECTED = 'REJECTED',
	TAX_INFORMATION_REGISTERED = 'TAX_INFORMATION_REGISTERED'
}

export type RegistryTaxInformation = {
	__typename?: 'RegistryTaxInformation';
	clabe?: Maybe<Scalars['String']['output']>;
	clabeBankName?: Maybe<Scalars['String']['output']>;
	correctionsRequested?: Maybe<Array<Maybe<TaxInformationCorrectableField>>>;
	eSignatureSerialNumber?: Maybe<Scalars['String']['output']>;
	rfc?: Maybe<Scalars['String']['output']>;
	taxRegimeCode?: Maybe<TaxRegimeCode>;
};

export type RejectRegistryInput = {
	clientId: Scalars['UUID7']['input'];
	deliberation: Scalars['String']['input'];
};

export type RejectRegistryPayload = {
	__typename?: 'RejectRegistryPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export enum RelationWithAddressHolder {
	CHILD = 'CHILD',
	FAMILY = 'FAMILY',
	MYSELF = 'MYSELF',
	OTHER = 'OTHER',
	PARENT = 'PARENT',
	SIBLING = 'SIBLING',
	TENANT = 'TENANT'
}

export type RequestCreditBureauReportInput = {
	clientId: Scalars['UUID7']['input'];
};

export type RequestCreditBureauReportPayload = {
	__typename?: 'RequestCreditBureauReportPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type RequestRegistryCorrectionsInput = {
	birthInformation?: InputMaybe<Array<BirthInformationCorrectableField>>;
	clientId: Scalars['UUID7']['input'];
	officialAddress?: InputMaybe<Array<OfficialAddressCorrectableField>>;
	onboardingChangesDescription: Scalars['String']['input'];
	personalInformation?: InputMaybe<Array<PersonalInformationCorrectableField>>;
	proofOfLife?: InputMaybe<Array<ProofOfLifeCorrectableField>>;
	taxInformation?: InputMaybe<Array<TaxInformationCorrectableField>>;
};

export type RequestRegistryCorrectionsPayload = {
	__typename?: 'RequestRegistryCorrectionsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export enum ResidenceType {
	OWNER = 'OWNER',
	PENSION_OR_WITH_FAMILY = 'PENSION_OR_WITH_FAMILY',
	RENTER = 'RENTER'
}

export enum ResponsibilityType {
	AUTHORIZED_USER = 'AUTHORIZED_USER',
	INDIVIDUAL = 'INDIVIDUAL',
	JOINT = 'JOINT',
	JOINTLY_OBLIGED = 'JOINTLY_OBLIGED'
}

export type RfcAnalysis = {
	__typename?: 'RfcAnalysis';
	blacklistStatus?: Maybe<Scalars['String']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
	observation?: Maybe<Scalars['String']['output']>;
	validatedRfc?: Maybe<Scalars['String']['output']>;
};

export type RootMutationType = {
	__typename?: 'RootMutationType';
	approveRegistry?: Maybe<ApproveRegistryPayload>;
	downloadRegistryDocuments?: Maybe<DownloadRegistryDocumentsPayload>;
	modifyDeliberation?: Maybe<ModifyDeliberationPayload>;
	rejectRegistry?: Maybe<RejectRegistryPayload>;
	requestCreditBureauReport?: Maybe<RequestCreditBureauReportPayload>;
	requestRegistryCorrections?: Maybe<RequestRegistryCorrectionsPayload>;
};

export type RootMutationTypeApproveRegistryArgs = {
	input: ApproveRegistryInput;
};

export type RootMutationTypeDownloadRegistryDocumentsArgs = {
	input: DownloadRegistryDocumentsInput;
};

export type RootMutationTypeModifyDeliberationArgs = {
	input: ModifyDeliberationInput;
};

export type RootMutationTypeRejectRegistryArgs = {
	input: RejectRegistryInput;
};

export type RootMutationTypeRequestCreditBureauReportArgs = {
	input: RequestCreditBureauReportInput;
};

export type RootMutationTypeRequestRegistryCorrectionsArgs = {
	input: RequestRegistryCorrectionsInput;
};

export type RootQueryType = {
	__typename?: 'RootQueryType';
	creditBureauAuthorizations?: Maybe<CreditBureauAuthorizationConnection>;
	node?: Maybe<Node>;
	registries?: Maybe<RegistryConnection>;
};

export type RootQueryTypeCreditBureauAuthorizationsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	filter?: InputMaybe<CreditBureauAuthorizationFilter>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sorts?: InputMaybe<Array<InputMaybe<CreditBureauAuthorizationSort>>>;
};

export type RootQueryTypeNodeArgs = {
	id: Scalars['ID']['input'];
};

export type RootQueryTypeRegistriesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	filter?: InputMaybe<RegistryFilter>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sorts?: InputMaybe<Array<InputMaybe<RegistrySort>>>;
};

export enum SortDirection {
	/** Ascending */
	ASC = 'ASC',
	/** Descending */
	DESC = 'DESC'
}

export enum SpecialAddressIndicator {
	KNOWN_ADDRESS = 'KNOWN_ADDRESS',
	MILITARY_ADDRESS = 'MILITARY_ADDRESS',
	RURAL_ADDRESS = 'RURAL_ADDRESS'
}

export enum TaxInformationCorrectableField {
	RFC = 'RFC'
}

export enum TaxRegimeCode {
	CODE_605 = 'CODE_605',
	CODE_606 = 'CODE_606',
	CODE_608 = 'CODE_608',
	CODE_611 = 'CODE_611',
	CODE_612 = 'CODE_612',
	CODE_614 = 'CODE_614',
	CODE_615 = 'CODE_615',
	CODE_616 = 'CODE_616',
	CODE_621 = 'CODE_621',
	CODE_622 = 'CODE_622',
	CODE_626 = 'CODE_626',
	CODE_629 = 'CODE_629',
	CODE_630 = 'CODE_630'
}

export enum TrialType {
	ACQUISITIVE_PRESCRIPTION = 'ACQUISITIVE_PRESCRIPTION',
	ADVERSE_POSSESSION = 'ADVERSE_POSSESSION',
	AMPARO_LAWSUIT = 'AMPARO_LAWSUIT',
	AMPARO_TRIAL = 'AMPARO_TRIAL',
	BANKRUPTCY_INSOLVENCY = 'BANKRUPTCY_INSOLVENCY',
	CHILD_SUPPORT = 'CHILD_SUPPORT',
	CHILD_SUPPORT_CANCELLATION = 'CHILD_SUPPORT_CANCELLATION',
	CHILD_SUPPORT_REDUCTION = 'CHILD_SUPPORT_REDUCTION',
	CIVIL = 'CIVIL',
	CIVIL_EXECUTIVE_PROCEEDING = 'CIVIL_EXECUTIVE_PROCEEDING',
	CIVIL_MORTGAGE_PROCEEDING = 'CIVIL_MORTGAGE_PROCEEDING',
	COMMERCIAL = 'COMMERCIAL',
	COMMERCIAL_EXECUTIVE_PROCEEDING = 'COMMERCIAL_EXECUTIVE_PROCEEDING',
	CONTESTED_DIVORCE = 'CONTESTED_DIVORCE',
	CRIMINAL = 'CRIMINAL',
	DAMAGES_AND_LOSSES = 'DAMAGES_AND_LOSSES',
	EVICTION = 'EVICTION',
	EXECUTIVE_PROCEEDING = 'EXECUTIVE_PROCEEDING',
	FAMILY = 'FAMILY',
	FAMILY_DISPUTE = 'FAMILY_DISPUTE',
	FIRST_REGISTRATION_OF_TITLE = 'FIRST_REGISTRATION_OF_TITLE',
	INJUNCTION_PROCEEDING = 'INJUNCTION_PROCEEDING',
	JACTITATION_ACTION = 'JACTITATION_ACTION',
	JUSTICE_OF_THE_PEACE = 'JUSTICE_OF_THE_PEACE',
	LABOR = 'LABOR',
	MANDATORY_DIVORCE = 'MANDATORY_DIVORCE',
	MORTGAGE_PROCEEDING = 'MORTGAGE_PROCEEDING',
	NOT_APPLICABLE = 'NOT_APPLICABLE',
	NULLITY = 'NULLITY',
	NULLITY_LAWSUIT = 'NULLITY_LAWSUIT',
	ORAL_CIVIL_PROCEEDING = 'ORAL_CIVIL_PROCEEDING',
	ORAL_COMMERCIAL_PROCEEDING = 'ORAL_COMMERCIAL_PROCEEDING',
	ORAL_FAMILY_PROCEEDING = 'ORAL_FAMILY_PROCEEDING',
	ORAL_MORTGAGE_PROCEEDING = 'ORAL_MORTGAGE_PROCEEDING',
	ORAL_PROCEEDING = 'ORAL_PROCEEDING',
	ORDINARY_CIVIL_PROCEEDING = 'ORDINARY_CIVIL_PROCEEDING',
	ORDINARY_COMMERCIAL_PROCEEDING = 'ORDINARY_COMMERCIAL_PROCEEDING',
	ORDINARY_PROCEEDING = 'ORDINARY_PROCEEDING',
	OTOR_FIR_ESC = 'OTOR_FIR_ESC',
	PESO_PAYMENT = 'PESO_PAYMENT',
	PLEDGE_PROCEEDING = 'PLEDGE_PROCEEDING',
	POSITIVE_PRESCRIPTION = 'POSITIVE_PRESCRIPTION',
	REAL_ESTATE_LEASE = 'REAL_ESTATE_LEASE',
	REIVINDICATORY_ACTION = 'REIVINDICATORY_ACTION',
	RESCISSION = 'RESCISSION',
	SPECIAL_MORTGAGE_PROCEEDING = 'SPECIAL_MORTGAGE_PROCEEDING',
	SPECIAL_SUMMARY_PROCEEDING = 'SPECIAL_SUMMARY_PROCEEDING',
	SUMMARY_CIVIL_PROCEEDING = 'SUMMARY_CIVIL_PROCEEDING',
	SUMMARY_MORTGAGE_PROCEEDING = 'SUMMARY_MORTGAGE_PROCEEDING',
	SUMMARY_PROCEEDING = 'SUMMARY_PROCEEDING',
	UNPUBLISHED = 'UNPUBLISHED',
	VERY_SUMMARY_CIVIL_PROCEEDING = 'VERY_SUMMARY_CIVIL_PROCEEDING',
	VOLUNTARY_JURISDICTION = 'VOLUNTARY_JURISDICTION'
}

export enum VerificationMethod {
	AUTOMATIC = 'AUTOMATIC',
	MANUAL = 'MANUAL'
}

export type DownloadRegistryDocumentsMutationVariables = Exact<{
	input: DownloadRegistryDocumentsInput;
}>;

export type DownloadRegistryDocumentsMutation = {
	__typename?: 'RootMutationType';
	downloadRegistryDocuments?: {
		__typename?: 'DownloadRegistryDocumentsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
		result?: {
			__typename?: 'RegistryDocuments';
			taxStatusCertificate?: string | null;
			proofOfAddress?: string | null;
			ineFront?: string | null;
			ineBack?: string | null;
			selfie?: string | null;
		} | null;
	} | null;
};

export type RequestRegistryCorrectionsMutationVariables = Exact<{
	input: RequestRegistryCorrectionsInput;
}>;

export type RequestRegistryCorrectionsMutation = {
	__typename?: 'RootMutationType';
	requestRegistryCorrections?: {
		__typename?: 'RequestRegistryCorrectionsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type RejectRegistryMutationVariables = Exact<{
	input: RejectRegistryInput;
}>;

export type RejectRegistryMutation = {
	__typename?: 'RootMutationType';
	rejectRegistry?: {
		__typename?: 'RejectRegistryPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ApproveRegistryMutationVariables = Exact<{
	input: ApproveRegistryInput;
}>;

export type ApproveRegistryMutation = {
	__typename?: 'RootMutationType';
	approveRegistry?: {
		__typename?: 'ApproveRegistryPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type RequestCreditBureauReportMutationVariables = Exact<{
	input: RequestCreditBureauReportInput;
}>;

export type RequestCreditBureauReportMutation = {
	__typename?: 'RootMutationType';
	requestCreditBureauReport?: {
		__typename?: 'RequestCreditBureauReportPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ModifyDeliberationMutationVariables = Exact<{
	input: ModifyDeliberationInput;
}>;

export type ModifyDeliberationMutation = {
	__typename?: 'RootMutationType';
	modifyDeliberation?: {
		__typename?: 'ModifyDeliberationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type GetNodeQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetNodeQuery = {
	__typename?: 'RootQueryType';
	node?:
		| { __typename?: 'CreditBureauAuthorization'; id: string }
		| {
				__typename?: 'Registry';
				clientId?: string | null;
				registryStatus?: RegistryStatus | null;
				onboardingStatus?: OnboardingStatus | null;
				phoneNumber?: string | null;
				email?: string | null;
				isCreditBureauApproved?: boolean | null;
				onboardingChangesDescription?: string | null;
				unicoAntifraudAnalysis?: { [key: string]: any } | null;
				creditBureauDefaultScore?: string | null;
				deliberation?: string | null;
				startedAt?: string | null;
				id: string;
				personalInformation?: {
					__typename?: 'RegistryPersonalInformation';
					names?: string | null;
					firstLastName?: string | null;
					secondLastName?: string | null;
					maritalStatus?: MaritalStatus | null;
					hasChildren?: boolean | null;
					facebookProfileUri?: string | null;
					curp?: string | null;
					correctionsRequested?: Array<PersonalInformationCorrectableField | null> | null;
				} | null;
				birthInformation?: {
					__typename?: 'RegistryBirthInformation';
					dateOfBirth?: string | null;
					countryOfBirth?: Country | null;
					mexStateOfBirth?: MexState | null;
					correctionsRequested?: Array<BirthInformationCorrectableField | null> | null;
				} | null;
				taxInformation?: {
					__typename?: 'RegistryTaxInformation';
					rfc?: string | null;
					taxRegimeCode?: TaxRegimeCode | null;
					clabe?: string | null;
					eSignatureSerialNumber?: string | null;
					clabeBankName?: string | null;
					correctionsRequested?: Array<TaxInformationCorrectableField | null> | null;
				} | null;
				officialAddress?: {
					__typename?: 'RegistryOfficialAddress';
					street?: string | null;
					externalNumber?: string | null;
					internalNumber?: string | null;
					colony?: string | null;
					municipalityOrDelegation?: string | null;
					city?: string | null;
					state?: string | null;
					betweenStreetsOne?: string | null;
					betweenStreetsTwo?: string | null;
					postalCode?: string | null;
					relationWithAddressHolder?: RelationWithAddressHolder | null;
					correctionsRequested?: Array<OfficialAddressCorrectableField | null> | null;
				} | null;
				proofOfLife?: {
					__typename?: 'RegistryProofOfLife';
					ipAddress?: string | null;
					locationLatitude?: string | null;
					locationLongitude?: string | null;
					correctionsRequested?: Array<ProofOfLifeCorrectableField | null> | null;
				} | null;
				antifraudAnalysis?: {
					__typename?: 'AntifraudAnalysis';
					label?: string | null;
					warnings?: Array<string | null> | null;
					identityFraudScore?: number | null;
					pep?: Array<{ [key: string]: any } | null> | null;
					sanctions?: Array<{ [key: string]: any } | null> | null;
					selfieAndOfficialIdMatch?: boolean | null;
					locationAndAddressDistance?: {
						__typename?: 'LocationAndAddressDistanceAnalysis';
						level?: string | null;
						observation?: string | null;
					} | null;
					address?: {
						__typename?: 'AddressAnalysis';
						validatedFullAddress?: string | null;
						isNearToPrison?: boolean | null;
						isOutsideOfTerritory?: boolean | null;
						isInsideOfPrison?: boolean | null;
						isInHighRiskLocation?: boolean | null;
						error?: string | null;
					} | null;
					location?: {
						__typename?: 'AddressAnalysis';
						validatedFullAddress?: string | null;
						isNearToPrison?: boolean | null;
						isOutsideOfTerritory?: boolean | null;
						isInsideOfPrison?: boolean | null;
						isInHighRiskLocation?: boolean | null;
						error?: string | null;
					} | null;
					rfc?: {
						__typename?: 'RfcAnalysis';
						blacklistStatus?: string | null;
						isValid?: boolean | null;
						observation?: string | null;
						validatedRfc?: string | null;
					} | null;
					officialIdRfc?: {
						__typename?: 'RfcAnalysis';
						blacklistStatus?: string | null;
						isValid?: boolean | null;
						observation?: string | null;
						validatedRfc?: string | null;
					} | null;
					curp?: {
						__typename?: 'CurpAnalysis';
						curp?: string | null;
						governmentName?: string | null;
						isValid?: boolean | null;
						dateOfBirth?: string | null;
						gender?: string | null;
						isMexican?: boolean | null;
						error?: string | null;
					} | null;
					officialIdCurp?: {
						__typename?: 'CurpAnalysis';
						curp?: string | null;
						governmentName?: string | null;
						isValid?: boolean | null;
						dateOfBirth?: string | null;
						gender?: string | null;
						isMexican?: boolean | null;
						error?: string | null;
					} | null;
					ine?: {
						__typename?: 'IneAnalysis';
						curp?: string | null;
						firstLastName?: string | null;
						secondLastName?: string | null;
						names?: string | null;
						validThru?: string | null;
						electoralKey?: string | null;
					} | null;
					passport?: {
						__typename?: 'PassportAnalysis';
						curp?: string | null;
						lastNames?: string | null;
						names?: string | null;
						dateOfBirth?: string | null;
						citizenship?: string | null;
						expirationDate?: string | null;
						passportNumber?: string | null;
					} | null;
					selfieFaceRecognition?: {
						__typename?: 'FaceRecognitionAnalysis';
						lastSeenInTrullyNetwork?: string | null;
						isMarkedAsFraudInTrullyNetwork?: boolean | null;
						timesSeenLastMonthInTrullyNetwork?: number | null;
						warnings?: Array<string | null> | null;
						companiesSeen?: number | null;
						gender?: string | null;
						confidenceScore?: string | null;
					} | null;
					officialIdFaceRecognition?: {
						__typename?: 'FaceRecognitionAnalysis';
						lastSeenInTrullyNetwork?: string | null;
						isMarkedAsFraudInTrullyNetwork?: boolean | null;
						timesSeenLastMonthInTrullyNetwork?: number | null;
						warnings?: Array<string | null> | null;
						companiesSeen?: number | null;
						gender?: string | null;
						confidenceScore?: string | null;
					} | null;
					ipAddress?: {
						__typename?: 'IpAddressAnalysis';
						isBlacklisted?: boolean | null;
						blacklistedCount?: number | null;
						isTorConnection?: boolean | null;
						isVpnConnection?: boolean | null;
					} | null;
					email?: {
						__typename?: 'EmailAnalysis';
						deliverability?: string | null;
						sanitizedEmail?: string | null;
						isValid?: boolean | null;
						isDisposable?: boolean | null;
						isLeaked?: boolean | null;
						isSpamHoneypot?: boolean | null;
						hasRecentAbuseInTrullyNetwork?: boolean | null;
						isFrequentComplainer?: boolean | null;
						spamTrapScore?: string | null;
						fraudScore?: number | null;
					} | null;
					phoneNumber?: {
						__typename?: 'PhoneNumberAnalysis';
						isValid?: boolean | null;
						isActive?: boolean | null;
						isDigitalPhoneNumber?: boolean | null;
						isSpammer?: boolean | null;
						isLeaked?: boolean | null;
						hasRecentAbuseInTrullyNetwork?: boolean | null;
						hasFraudulentBehavior?: boolean | null;
						carrier?: string | null;
						country?: string | null;
						city?: string | null;
						fraudScore?: number | null;
						onWhatsapp?: boolean | null;
					} | null;
				} | null;
				creditBureauReport?: {
					__typename?: 'CreditBureauReport';
					ratingAi?: string | null;
					header?: {
						__typename?: 'CreditBureauHeader';
						operatorReferenceNumber?: string | null;
						countryCode?: string | null;
						bureauIdentifier?: string | null;
						grantorCode?: string | null;
						primaryConsumerReturnCode?: string | null;
						secondaryConsumerReturnCode?: string | null;
						inquiryControlNumber?: string | null;
						version?: string | null;
					} | null;
					person?: {
						__typename?: 'CreditBureauPerson';
						firstLastName?: string | null;
						secondLastName?: string | null;
						additionalLastName?: string | null;
						firstName?: string | null;
						middleName?: string | null;
						dateOfBirth?: string | null;
						rfc?: string | null;
						namePrefix?: string | null;
						nameSuffix?: string | null;
						nationality?: string | null;
						residenceType?: ResidenceType | null;
						driversLicenseNumber?: string | null;
						maritalStatus?: CreditBureauMaritalStatus | null;
						gender?: string | null;
						professionalLicenseNumber?: string | null;
						voterRegistrationNumber?: string | null;
						foreignCountryCode?: string | null;
						numberOfDependents?: string | null;
						agesOfDependents?: string | null;
						dependentInformationReceiptDate?: string | null;
						dateOfDeath?: string | null;
						foreignTaxCode?: string | null;
					} | null;
					addresses?: Array<{
						__typename?: 'CreditBureauAddress';
						addressLine1?: string | null;
						addressLine2?: string | null;
						municipalityDelegation?: string | null;
						stateCode?: MexState | null;
						postalCode?: string | null;
						countryCode?: string | null;
						neighborhood?: string | null;
						addressReportDate?: string | null;
						residenceDate?: string | null;
						phoneNumber?: string | null;
						extension?: string | null;
						fax?: string | null;
						addressType?: AddressType | null;
						specialAddressIndicator?: SpecialAddressIndicator | null;
					} | null> | null;
					employments?: Array<{
						__typename?: 'CreditBureauEmployment';
						companyName?: string | null;
						disputedRecord?: boolean | null;
						addressLine1?: string | null;
						addressLine2?: string | null;
						neighborhood?: string | null;
						municipalityDelegation?: string | null;
						city?: string | null;
						stateCode?: MexState | null;
						postalCode?: string | null;
						phoneNumber?: string | null;
						extension?: string | null;
						fax?: string | null;
						jobTitle?: string | null;
						hireDate?: string | null;
						salary?: string | null;
						salaryBasis?: string | null;
						employeeNumber?: string | null;
						lastEmploymentDate?: string | null;
						countryCode?: string | null;
						employmentReportDate?: string | null;
						verificationDate?: string | null;
						verificationMethod?: VerificationMethod | null;
					} | null> | null;
					accounts?: Array<{
						__typename?: 'CreditBureauAccount';
						updateDate?: string | null;
						disputedRecord?: boolean | null;
						grantorCode?: string | null;
						grantorName?: string | null;
						grantorPhoneNumber?: string | null;
						currentAccountNumber?: string | null;
						creditInfoSocietyIdentifier?: string | null;
						responsibilityType?: ResponsibilityType | null;
						accountType?: AccountType | null;
						contractType?: ContractType | null;
						currencyCode?: string | null;
						assetValuationValue?: string | null;
						numberOfPayments?: string | null;
						paymentFrequency?: PaymentFrequency | null;
						paymentAmount?: string | null;
						accountOpeningDate?: string | null;
						lastPaymentDate?: string | null;
						lastPurchaseDate?: string | null;
						accountClosingDate?: string | null;
						reportDate?: string | null;
						reportingMethod?: string | null;
						lastZeroBalanceDate?: string | null;
						collateral?: string | null;
						maximumCredit?: string | null;
						currentBalance?: string | null;
						creditLimit?: string | null;
						overdueBalance?: string | null;
						numberOfOverduePayments?: string | null;
						paymentStatus?: string | null;
						paymentHistory?: string | null;
						paymentHistoryStartDate?: string | null;
						paymentHistoryEndDate?: string | null;
						observationCode?: string | null;
						totalReportedPayments?: string | null;
						payments1Or29DaysLate?: string | null;
						payments30Or59DaysLate?: string | null;
						payments60Or89DaysLate?: string | null;
						payments90Or119DaysLate?: string | null;
						highestDelinquencyAmount?: string | null;
						restructuringStartDate?: string | null;
						worstDelinquencyDate?: string | null;
						worstPaymentStatus?: string | null;
						lastPaymentAmount?: string | null;
						creditIdentifier?: string | null;
						emailAddress?: string | null;
						payrollCreditIdentifier?: string | null;
						payrollCreditOpenDate?: string | null;
						payrollCreditCancelDate?: string | null;
						payrollCreditHistory?: string | null;
						payrollCreditHistoryStartDate?: string | null;
						payrollCreditHistoryEndDate?: string | null;
					} | null> | null;
					creditInquiries?: Array<{
						__typename?: 'CreditBureauCreditInquiry';
						grantorCode?: string | null;
						grantorName?: string | null;
						inquiryDate?: string | null;
						isNewConsumer?: boolean | null;
						inquiryOriginIdentifier?: InquiryOriginIdentifier | null;
						contractAmount?: string | null;
						responsibilityType?: ResponsibilityType | null;
						contractType?: ContractType | null;
					} | null> | null;
					creditScores?: Array<{
						__typename?: 'CreditBureauCreditScore';
						scoreCode?: string | null;
						scoreName?: string | null;
						scoreValue?: string | null;
						reasonCodes?: Array<string | null> | null;
					} | null> | null;
					summary?: {
						__typename?: 'CreditBureauSummary';
						numberOfAccounts?: string | null;
						numberOfAccountsWithoutLatePayments?: string | null;
						numberOfRecentAccountsWithoutClassification?: string | null;
						accountsCurrent?: string | null;
						accountsWith1Or29DaysLatePayment?: string | null;
						accountsWith30Or59DaysLatePayment?: string | null;
						accountsWith60Or89DaysLatePayment?: string | null;
						accountsWith90Or119DaysLatePayment?: string | null;
						accountsWith120To149DaysLatePayment?: string | null;
						accountsWith150To365DaysLatePayment?: string | null;
						accountsWith365PlusDaysLatePayment?: string | null;
						accountsWithCommitedFraud?: string | null;
						alertMessages?: string | null;
						totalRevolvingOverdueBalances?: string | null;
						totalFixedPayments?: string | null;
						totalRevolvingCurrentBalances?: string | null;
						totalCollectionAgenciesRequests?: string | null;
						totalReportRequests?: string | null;
						disputedAccounts?: string | null;
						accountsWithNegativeHistory?: string | null;
						oldestAccountOpeningDate?: string | null;
						newAddressReportedLast60Days?: boolean | null;
						numberOfInquiriesLast6Months?: string | null;
						fixedPaymentMortgageAccounts?: string | null;
						closedAccounts?: string | null;
						openRevolvingAccounts?: string | null;
						totalRevolvingPayments?: string | null;
						mostRecentCollectionAgencyRequestDate?: string | null;
						consumerStatementsExistence?: boolean | null;
						mostRecentReportRequestDate?: string | null;
						totalRevolvingMaximumCredits?: string | null;
						mostRecentCollectionAgencyAccountOpeningDate?: string | null;
						currentNegativeAccounts?: string | null;
						databaseEntryDate?: string | null;
						revolvingCreditUtilizationPercentage?: string | null;
						totalFixedPaymentCurrentBalances?: string | null;
						mostRecentAccountOpeningDate?: string | null;
					} | null;
					hawkAlertDb?: Array<{
						__typename?: 'HawkAlert';
						reportDate?: string | null;
						keyCode?: string | null;
						institutionType?: string | null;
						message?: string | null;
						typeOfJury?: JuryType | null;
						typeOfTrial?: TrialType | null;
					} | null> | null;
					hawkAlertConsulta?: Array<{
						__typename?: 'HawkAlert';
						reportDate?: string | null;
						keyCode?: string | null;
						institutionType?: string | null;
						message?: string | null;
						typeOfJury?: JuryType | null;
						typeOfTrial?: TrialType | null;
					} | null> | null;
				} | null;
				creditSummaryBureauReport?: {
					__typename?: 'CreditSummaryBureauReport';
					utilizationPrePandemic?: string | null;
					utilizationPostPandemic?: string | null;
					monthsOverdue?: number | null;
					yearsInCreditBureau?: number | null;
					lastSixMonthsInquiries?: number | null;
					totalTrials?: number | null;
					trials?: Array<TrialType | null> | null;
					accounts?: Array<{
						__typename?: 'CreditSummaryBureauReportAccounts';
						paymentStatus?: PaymentStatus | null;
						openAccounts?: {
							__typename?: 'CreditSummaryBureauReportOpenAccounts';
							numberOfAccounts?: number | null;
							limitBalance?: string | null;
							maximumBalance?: string | null;
							currentBalance?: string | null;
							amount?: string | null;
							monthlyPayment?: string | null;
						} | null;
						closedAccounts?: {
							__typename?: 'CreditSummaryBureauReportClosedAccounts';
							numberOfAccounts?: number | null;
							limitBalance?: string | null;
							maximumBalance?: string | null;
							currentBalance?: string | null;
							amount?: string | null;
							monthlyPayment?: string | null;
						} | null;
					} | null> | null;
				} | null;
		  }
		| null;
};

export type RegistriesQueryVariables = Exact<{
	after?: InputMaybe<Scalars['String']['input']>;
	first?: InputMaybe<Scalars['Int']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sorts?: InputMaybe<Array<InputMaybe<RegistrySort>> | InputMaybe<RegistrySort>>;
	filter?: InputMaybe<RegistryFilter>;
}>;

export type RegistriesQuery = {
	__typename?: 'RootQueryType';
	registries?: {
		__typename?: 'RegistryConnection';
		count?: number | null;
		pageInfo: {
			__typename?: 'PageInfo';
			hasPreviousPage: boolean;
			hasNextPage: boolean;
			startCursor?: string | null;
			endCursor?: string | null;
		};
		edges?: Array<{
			__typename?: 'RegistryEdge';
			cursor?: string | null;
			node?: {
				__typename?: 'Registry';
				id: string;
				clientId?: string | null;
				registryStatus?: RegistryStatus | null;
				onboardingStatus?: OnboardingStatus | null;
				phoneNumber?: string | null;
				email?: string | null;
				creditBureauDefaultScore?: string | null;
				startedAt?: string | null;
				personalInformation?: {
					__typename?: 'RegistryPersonalInformation';
					names?: string | null;
					firstLastName?: string | null;
					secondLastName?: string | null;
					maritalStatus?: MaritalStatus | null;
					hasChildren?: boolean | null;
					facebookProfileUri?: string | null;
					curp?: string | null;
				} | null;
				taxInformation?: { __typename?: 'RegistryTaxInformation'; rfc?: string | null } | null;
				birthInformation?: {
					__typename?: 'RegistryBirthInformation';
					dateOfBirth?: string | null;
				} | null;
				creditBureauReport?: {
					__typename?: 'CreditBureauReport';
					summary?: {
						__typename?: 'CreditBureauSummary';
						numberOfAccounts?: string | null;
						accountsCurrent?: string | null;
						accountsWithNegativeHistory?: string | null;
						currentNegativeAccounts?: string | null;
						revolvingCreditUtilizationPercentage?: string | null;
					} | null;
					creditScores?: Array<{
						__typename?: 'CreditBureauCreditScore';
						scoreName?: string | null;
						scoreValue?: string | null;
					} | null> | null;
				} | null;
				creditSummaryBureauReport?: {
					__typename?: 'CreditSummaryBureauReport';
					utilizationPrePandemic?: string | null;
					utilizationPostPandemic?: string | null;
					monthsOverdue?: number | null;
					yearsInCreditBureau?: number | null;
					lastSixMonthsInquiries?: number | null;
					totalTrials?: number | null;
					trials?: Array<TrialType | null> | null;
					accounts?: Array<{
						__typename?: 'CreditSummaryBureauReportAccounts';
						paymentStatus?: PaymentStatus | null;
						openAccounts?: {
							__typename?: 'CreditSummaryBureauReportOpenAccounts';
							numberOfAccounts?: number | null;
							limitBalance?: string | null;
							maximumBalance?: string | null;
							currentBalance?: string | null;
							amount?: string | null;
							monthlyPayment?: string | null;
						} | null;
						closedAccounts?: {
							__typename?: 'CreditSummaryBureauReportClosedAccounts';
							numberOfAccounts?: number | null;
							limitBalance?: string | null;
							maximumBalance?: string | null;
							currentBalance?: string | null;
							amount?: string | null;
							monthlyPayment?: string | null;
						} | null;
					} | null> | null;
				} | null;
			} | null;
		} | null> | null;
	} | null;
};

export type CreditBureauAuthorizationsQueryVariables = Exact<{
	after?: InputMaybe<Scalars['String']['input']>;
	first?: InputMaybe<Scalars['Int']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sorts?: InputMaybe<
		Array<InputMaybe<CreditBureauAuthorizationSort>> | InputMaybe<CreditBureauAuthorizationSort>
	>;
	filter?: InputMaybe<CreditBureauAuthorizationFilter>;
}>;

export type CreditBureauAuthorizationsQuery = {
	__typename?: 'RootQueryType';
	creditBureauAuthorizations?: {
		__typename?: 'CreditBureauAuthorizationConnection';
		count?: number | null;
		pageInfo: {
			__typename?: 'PageInfo';
			hasPreviousPage: boolean;
			hasNextPage: boolean;
			startCursor?: string | null;
			endCursor?: string | null;
		};
		edges?: Array<{
			__typename?: 'CreditBureauAuthorizationEdge';
			cursor?: string | null;
			node?: {
				__typename?: 'CreditBureauAuthorization';
				id: string;
				creditBureauReportRequestId?: string | null;
				requestId?: string | null;
				requestDate?: string | null;
				fullName?: string | null;
				wasNipRequested?: boolean | null;
				wasAuthorized?: boolean | null;
				rfc?: string | null;
				successful?: boolean | null;
				officialAddress?: {
					__typename?: 'OfficialAddress';
					street?: string | null;
					externalNumber?: string | null;
					internalNumber?: string | null;
					colony?: string | null;
					municipalityOrDelegation?: string | null;
					city?: string | null;
					state?: string | null;
					postalCode?: string | null;
				} | null;
			} | null;
		} | null> | null;
	} | null;
};

export const DownloadRegistryDocumentsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'DownloadRegistryDocuments' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'DownloadRegistryDocumentsInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'downloadRegistryDocuments' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'result' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'taxStatusCertificate' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'proofOfAddress' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'ineFront' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'ineBack' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'selfie' } }
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type DownloadRegistryDocumentsMutationFn = Apollo.MutationFunction<
	DownloadRegistryDocumentsMutation,
	DownloadRegistryDocumentsMutationVariables
>;

/**
 * __useDownloadRegistryDocumentsMutation__
 *
 * To run a mutation, you first call `useDownloadRegistryDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadRegistryDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadRegistryDocumentsMutation, { data, loading, error }] = useDownloadRegistryDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadRegistryDocumentsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DownloadRegistryDocumentsMutation,
		DownloadRegistryDocumentsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DownloadRegistryDocumentsMutation,
		DownloadRegistryDocumentsMutationVariables
	>(DownloadRegistryDocumentsDocument, options);
}
export type DownloadRegistryDocumentsMutationHookResult = ReturnType<
	typeof useDownloadRegistryDocumentsMutation
>;
export type DownloadRegistryDocumentsMutationResult =
	Apollo.MutationResult<DownloadRegistryDocumentsMutation>;
export type DownloadRegistryDocumentsMutationOptions = Apollo.BaseMutationOptions<
	DownloadRegistryDocumentsMutation,
	DownloadRegistryDocumentsMutationVariables
>;
export const RequestRegistryCorrectionsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'RequestRegistryCorrections' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'RequestRegistryCorrectionsInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requestRegistryCorrections' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type RequestRegistryCorrectionsMutationFn = Apollo.MutationFunction<
	RequestRegistryCorrectionsMutation,
	RequestRegistryCorrectionsMutationVariables
>;

/**
 * __useRequestRegistryCorrectionsMutation__
 *
 * To run a mutation, you first call `useRequestRegistryCorrectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestRegistryCorrectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestRegistryCorrectionsMutation, { data, loading, error }] = useRequestRegistryCorrectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestRegistryCorrectionsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RequestRegistryCorrectionsMutation,
		RequestRegistryCorrectionsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RequestRegistryCorrectionsMutation,
		RequestRegistryCorrectionsMutationVariables
	>(RequestRegistryCorrectionsDocument, options);
}
export type RequestRegistryCorrectionsMutationHookResult = ReturnType<
	typeof useRequestRegistryCorrectionsMutation
>;
export type RequestRegistryCorrectionsMutationResult =
	Apollo.MutationResult<RequestRegistryCorrectionsMutation>;
export type RequestRegistryCorrectionsMutationOptions = Apollo.BaseMutationOptions<
	RequestRegistryCorrectionsMutation,
	RequestRegistryCorrectionsMutationVariables
>;
export const RejectRegistryDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'RejectRegistry' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'RejectRegistryInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rejectRegistry' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type RejectRegistryMutationFn = Apollo.MutationFunction<
	RejectRegistryMutation,
	RejectRegistryMutationVariables
>;

/**
 * __useRejectRegistryMutation__
 *
 * To run a mutation, you first call `useRejectRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRegistryMutation, { data, loading, error }] = useRejectRegistryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectRegistryMutation(
	baseOptions?: Apollo.MutationHookOptions<RejectRegistryMutation, RejectRegistryMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RejectRegistryMutation, RejectRegistryMutationVariables>(
		RejectRegistryDocument,
		options
	);
}
export type RejectRegistryMutationHookResult = ReturnType<typeof useRejectRegistryMutation>;
export type RejectRegistryMutationResult = Apollo.MutationResult<RejectRegistryMutation>;
export type RejectRegistryMutationOptions = Apollo.BaseMutationOptions<
	RejectRegistryMutation,
	RejectRegistryMutationVariables
>;
export const ApproveRegistryDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ApproveRegistry' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApproveRegistryInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'approveRegistry' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ApproveRegistryMutationFn = Apollo.MutationFunction<
	ApproveRegistryMutation,
	ApproveRegistryMutationVariables
>;

/**
 * __useApproveRegistryMutation__
 *
 * To run a mutation, you first call `useApproveRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRegistryMutation, { data, loading, error }] = useApproveRegistryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveRegistryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApproveRegistryMutation,
		ApproveRegistryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ApproveRegistryMutation, ApproveRegistryMutationVariables>(
		ApproveRegistryDocument,
		options
	);
}
export type ApproveRegistryMutationHookResult = ReturnType<typeof useApproveRegistryMutation>;
export type ApproveRegistryMutationResult = Apollo.MutationResult<ApproveRegistryMutation>;
export type ApproveRegistryMutationOptions = Apollo.BaseMutationOptions<
	ApproveRegistryMutation,
	ApproveRegistryMutationVariables
>;
export const RequestCreditBureauReportDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'RequestCreditBureauReport' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'RequestCreditBureauReportInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requestCreditBureauReport' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type RequestCreditBureauReportMutationFn = Apollo.MutationFunction<
	RequestCreditBureauReportMutation,
	RequestCreditBureauReportMutationVariables
>;

/**
 * __useRequestCreditBureauReportMutation__
 *
 * To run a mutation, you first call `useRequestCreditBureauReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCreditBureauReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCreditBureauReportMutation, { data, loading, error }] = useRequestCreditBureauReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCreditBureauReportMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RequestCreditBureauReportMutation,
		RequestCreditBureauReportMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RequestCreditBureauReportMutation,
		RequestCreditBureauReportMutationVariables
	>(RequestCreditBureauReportDocument, options);
}
export type RequestCreditBureauReportMutationHookResult = ReturnType<
	typeof useRequestCreditBureauReportMutation
>;
export type RequestCreditBureauReportMutationResult =
	Apollo.MutationResult<RequestCreditBureauReportMutation>;
export type RequestCreditBureauReportMutationOptions = Apollo.BaseMutationOptions<
	RequestCreditBureauReportMutation,
	RequestCreditBureauReportMutationVariables
>;
export const ModifyDeliberationDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ModifyDeliberation' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ModifyDeliberationInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'modifyDeliberation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ModifyDeliberationMutationFn = Apollo.MutationFunction<
	ModifyDeliberationMutation,
	ModifyDeliberationMutationVariables
>;

/**
 * __useModifyDeliberationMutation__
 *
 * To run a mutation, you first call `useModifyDeliberationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyDeliberationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyDeliberationMutation, { data, loading, error }] = useModifyDeliberationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyDeliberationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ModifyDeliberationMutation,
		ModifyDeliberationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ModifyDeliberationMutation, ModifyDeliberationMutationVariables>(
		ModifyDeliberationDocument,
		options
	);
}
export type ModifyDeliberationMutationHookResult = ReturnType<typeof useModifyDeliberationMutation>;
export type ModifyDeliberationMutationResult = Apollo.MutationResult<ModifyDeliberationMutation>;
export type ModifyDeliberationMutationOptions = Apollo.BaseMutationOptions<
	ModifyDeliberationMutation,
	ModifyDeliberationMutationVariables
>;
export const GetNodeDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'GetNode' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'node' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'InlineFragment',
									typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Registry' } },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'registryStatus' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'isCreditBureauApproved' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'onboardingChangesDescription' }
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'personalInformation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'maritalStatus' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'hasChildren' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'facebookProfileUri' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'curp' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'correctionsRequested' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'birthInformation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'countryOfBirth' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'mexStateOfBirth' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'correctionsRequested' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'taxInformation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'rfc' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'taxRegimeCode' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'clabe' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'eSignatureSerialNumber' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'clabeBankName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'correctionsRequested' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'officialAddress' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'street' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'externalNumber' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'internalNumber' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'colony' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'municipalityOrDelegation' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'city' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'state' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'betweenStreetsOne' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'betweenStreetsTwo' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'relationWithAddressHolder' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'correctionsRequested' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'proofOfLife' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'locationLatitude' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'locationLongitude' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'correctionsRequested' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'antifraudAnalysis' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'label' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'identityFraudScore' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'pep' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'sanctions' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'selfieAndOfficialIdMatch' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'locationAndAddressDistance' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'level' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'observation' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'address' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'validatedFullAddress' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isNearToPrison' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isOutsideOfTerritory' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isInsideOfPrison' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isInHighRiskLocation' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'error' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'location' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'validatedFullAddress' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isNearToPrison' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isOutsideOfTerritory' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isInsideOfPrison' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isInHighRiskLocation' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'error' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'rfc' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'blacklistStatus' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'isValid' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'observation' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'validatedRfc' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'officialIdRfc' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'blacklistStatus' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'isValid' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'observation' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'validatedRfc' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'curp' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'curp' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'governmentName' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'isValid' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'gender' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'isMexican' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'error' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'officialIdCurp' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'curp' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'governmentName' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'isValid' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'gender' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'isMexican' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'error' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'ine' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'curp' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'secondLastName' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'validThru' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'electoralKey' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'passport' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'curp' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'lastNames' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'citizenship' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'expirationDate' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'selfieFaceRecognition' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'lastSeenInTrullyNetwork' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isMarkedAsFraudInTrullyNetwork' }
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'timesSeenLastMonthInTrullyNetwork'
																		}
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'companiesSeen' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'gender' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'confidenceScore' }
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'officialIdFaceRecognition' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'lastSeenInTrullyNetwork' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isMarkedAsFraudInTrullyNetwork' }
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'timesSeenLastMonthInTrullyNetwork'
																		}
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'warnings' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'companiesSeen' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'gender' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'confidenceScore' }
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'ipAddress' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'isBlacklisted' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'blacklistedCount' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isTorConnection' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isVpnConnection' }
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'email' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'deliverability' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'sanitizedEmail' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'isValid' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'isDisposable' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'isLeaked' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isSpamHoneypot' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'hasRecentAbuseInTrullyNetwork' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isFrequentComplainer' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'spamTrapScore' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'fraudScore' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'phoneNumber' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'isValid' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'isDigitalPhoneNumber' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'isSpammer' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'isLeaked' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'hasRecentAbuseInTrullyNetwork' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'hasFraudulentBehavior' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'carrier' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'country' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'city' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'fraudScore' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'onWhatsapp' } }
																]
															}
														}
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'unicoAntifraudAnalysis' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'creditBureauDefaultScore' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'creditBureauReport' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'ratingAi' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'header' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'operatorReferenceNumber' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'bureauIdentifier' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'grantorCode' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'primaryConsumerReturnCode' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'secondaryConsumerReturnCode' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'inquiryControlNumber' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'version' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'person' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'secondLastName' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'additionalLastName' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'middleName' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'rfc' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'namePrefix' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'nameSuffix' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'nationality' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'residenceType' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'driversLicenseNumber' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'maritalStatus' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'gender' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'professionalLicenseNumber' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'voterRegistrationNumber' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'foreignCountryCode' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'numberOfDependents' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'agesOfDependents' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'dependentInformationReceiptDate' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'dateOfDeath' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'foreignTaxCode' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'addresses' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'municipalityDelegation' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'neighborhood' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'addressReportDate' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'residenceDate' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'extension' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'fax' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'addressType' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'specialAddressIndicator' }
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'employments' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'disputedRecord' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'neighborhood' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'municipalityDelegation' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'city' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'extension' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'fax' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'hireDate' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'salary' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'salaryBasis' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'employeeNumber' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'lastEmploymentDate' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'employmentReportDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'verificationDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'verificationMethod' }
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'accounts' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'updateDate' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'disputedRecord' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'grantorCode' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'grantorName' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'grantorPhoneNumber' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'currentAccountNumber' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'creditInfoSocietyIdentifier' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'responsibilityType' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'contractType' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'assetValuationValue' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'numberOfPayments' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'paymentFrequency' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'paymentAmount' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'accountOpeningDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'lastPaymentDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'lastPurchaseDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'accountClosingDate' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'reportingMethod' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'lastZeroBalanceDate' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'collateral' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'maximumCredit' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'currentBalance' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'creditLimit' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'overdueBalance' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'numberOfOverduePayments' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'paymentStatus' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'paymentHistory' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'paymentHistoryStartDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'paymentHistoryEndDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'observationCode' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'totalReportedPayments' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'payments1Or29DaysLate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'payments30Or59DaysLate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'payments60Or89DaysLate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'payments90Or119DaysLate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'highestDelinquencyAmount' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'restructuringStartDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'worstDelinquencyDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'worstPaymentStatus' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'lastPaymentAmount' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'creditIdentifier' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'payrollCreditIdentifier' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'payrollCreditOpenDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'payrollCreditCancelDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'payrollCreditHistory' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'payrollCreditHistoryStartDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'payrollCreditHistoryEndDate' }
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditInquiries' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'grantorCode' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'grantorName' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'inquiryDate' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'isNewConsumer' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'inquiryOriginIdentifier' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'contractAmount' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'responsibilityType' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'contractType' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditScores' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'scoreCode' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'scoreName' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'scoreValue' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'reasonCodes' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'summary' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'numberOfAccounts' }
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'numberOfAccountsWithoutLatePayments'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'numberOfRecentAccountsWithoutClassification'
																		}
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'accountsCurrent' }
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'accountsWith1Or29DaysLatePayment'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'accountsWith30Or59DaysLatePayment'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'accountsWith60Or89DaysLatePayment'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'accountsWith90Or119DaysLatePayment'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'accountsWith120To149DaysLatePayment'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'accountsWith150To365DaysLatePayment'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'accountsWith365PlusDaysLatePayment'
																		}
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'accountsWithCommitedFraud' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'alertMessages' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'totalRevolvingOverdueBalances' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'totalFixedPayments' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'totalRevolvingCurrentBalances' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'totalCollectionAgenciesRequests' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'totalReportRequests' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'disputedAccounts' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'accountsWithNegativeHistory' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'oldestAccountOpeningDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'newAddressReportedLast60Days' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'numberOfInquiriesLast6Months' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'fixedPaymentMortgageAccounts' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'closedAccounts' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'openRevolvingAccounts' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'totalRevolvingPayments' }
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'mostRecentCollectionAgencyRequestDate'
																		}
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'consumerStatementsExistence' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'mostRecentReportRequestDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'totalRevolvingMaximumCredits' }
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'mostRecentCollectionAgencyAccountOpeningDate'
																		}
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'currentNegativeAccounts' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'databaseEntryDate' }
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'revolvingCreditUtilizationPercentage'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'totalFixedPaymentCurrentBalances'
																		}
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'mostRecentAccountOpeningDate' }
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'hawkAlertDb' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'keyCode' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'institutionType' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'typeOfJury' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'typeOfTrial' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'hawkAlertConsulta' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'keyCode' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'institutionType' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'typeOfJury' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'typeOfTrial' } }
																]
															}
														}
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'creditSummaryBureauReport' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'utilizationPrePandemic' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'utilizationPostPandemic' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'monthsOverdue' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'yearsInCreditBureau' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'lastSixMonthsInquiries' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'accounts' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'paymentStatus' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'openAccounts' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'numberOfAccounts' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'limitBalance' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'maximumBalance' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'currentBalance' }
																				},
																				{ kind: 'Field', name: { kind: 'Name', value: 'amount' } },
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'monthlyPayment' }
																				}
																			]
																		}
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'closedAccounts' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'numberOfAccounts' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'limitBalance' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'maximumBalance' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'currentBalance' }
																				},
																				{ kind: 'Field', name: { kind: 'Name', value: 'amount' } },
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'monthlyPayment' }
																				}
																			]
																		}
																	}
																]
															}
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'totalTrials' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'trials' } }
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'deliberation' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } }
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useGetNodeQuery__
 *
 * To run a query within a React component, call `useGetNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNodeQuery(
	baseOptions: Apollo.QueryHookOptions<GetNodeQuery, GetNodeQueryVariables> &
		({ variables: GetNodeQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
}
export function useGetNodeLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetNodeQuery, GetNodeQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
}
export function useGetNodeSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetNodeQuery, GetNodeQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
}
export type GetNodeQueryHookResult = ReturnType<typeof useGetNodeQuery>;
export type GetNodeLazyQueryHookResult = ReturnType<typeof useGetNodeLazyQuery>;
export type GetNodeSuspenseQueryHookResult = ReturnType<typeof useGetNodeSuspenseQuery>;
export type GetNodeQueryResult = Apollo.QueryResult<GetNodeQuery, GetNodeQueryVariables>;
export function refetchGetNodeQuery(variables: GetNodeQueryVariables) {
	return { query: GetNodeDocument, variables: variables };
}
export const RegistriesDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'Registries' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'sorts' } },
					type: {
						kind: 'ListType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistrySort' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFilter' } }
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'registries' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'before' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'last' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'sorts' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'sorts' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'pageInfo' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'edges' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'node' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'registryStatus' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'personalInformation' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'secondLastName' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'maritalStatus' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'hasChildren' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'facebookProfileUri' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'curp' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'taxInformation' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'rfc' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'birthInformation' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditBureauReport' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'summary' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'numberOfAccounts' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'accountsCurrent' }
																				},
																				{
																					kind: 'Field',
																					name: {
																						kind: 'Name',
																						value: 'accountsWithNegativeHistory'
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'currentNegativeAccounts' }
																				},
																				{
																					kind: 'Field',
																					name: {
																						kind: 'Name',
																						value: 'revolvingCreditUtilizationPercentage'
																					}
																				}
																			]
																		}
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'creditScores' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'scoreName' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'scoreValue' }
																				}
																			]
																		}
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditBureauDefaultScore' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditSummaryBureauReport' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'utilizationPrePandemic' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'utilizationPostPandemic' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'monthsOverdue' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'yearsInCreditBureau' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'lastSixMonthsInquiries' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'accounts' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'paymentStatus' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'openAccounts' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'numberOfAccounts' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'limitBalance' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'maximumBalance' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'currentBalance' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'amount' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'monthlyPayment' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'closedAccounts' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'numberOfAccounts' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'limitBalance' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'maximumBalance' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'currentBalance' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'amount' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'monthlyPayment' }
																							}
																						]
																					}
																				}
																			]
																		}
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'totalTrials' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'trials' } }
																]
															}
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } }
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'count' },
									arguments: [
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'filter' },
											value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }
										}
									]
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useRegistriesQuery__
 *
 * To run a query within a React component, call `useRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistriesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sorts: // value for 'sorts'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRegistriesQuery(
	baseOptions?: Apollo.QueryHookOptions<RegistriesQuery, RegistriesQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RegistriesQuery, RegistriesQueryVariables>(RegistriesDocument, options);
}
export function useRegistriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RegistriesQuery, RegistriesQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RegistriesQuery, RegistriesQueryVariables>(
		RegistriesDocument,
		options
	);
}
export function useRegistriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<RegistriesQuery, RegistriesQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RegistriesQuery, RegistriesQueryVariables>(
		RegistriesDocument,
		options
	);
}
export type RegistriesQueryHookResult = ReturnType<typeof useRegistriesQuery>;
export type RegistriesLazyQueryHookResult = ReturnType<typeof useRegistriesLazyQuery>;
export type RegistriesSuspenseQueryHookResult = ReturnType<typeof useRegistriesSuspenseQuery>;
export type RegistriesQueryResult = Apollo.QueryResult<RegistriesQuery, RegistriesQueryVariables>;
export function refetchRegistriesQuery(variables?: RegistriesQueryVariables) {
	return { query: RegistriesDocument, variables: variables };
}
export const CreditBureauAuthorizationsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'CreditBureauAuthorizations' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'sorts' } },
					type: {
						kind: 'ListType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'CreditBureauAuthorizationSort' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
					type: {
						kind: 'NamedType',
						name: { kind: 'Name', value: 'CreditBureauAuthorizationFilter' }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'creditBureauAuthorizations' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'before' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'last' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'sorts' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'sorts' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'pageInfo' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'edges' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'node' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditBureauReportRequestId' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'officialAddress' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'street' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'externalNumber' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'internalNumber' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'colony' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'municipalityOrDelegation' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'city' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'state' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'postalCode' } }
																]
															}
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'wasNipRequested' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'wasAuthorized' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'rfc' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'successful' } }
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'count' },
									arguments: [
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'filter' },
											value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }
										}
									]
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useCreditBureauAuthorizationsQuery__
 *
 * To run a query within a React component, call `useCreditBureauAuthorizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditBureauAuthorizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditBureauAuthorizationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sorts: // value for 'sorts'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreditBureauAuthorizationsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CreditBureauAuthorizationsQuery,
		CreditBureauAuthorizationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CreditBureauAuthorizationsQuery, CreditBureauAuthorizationsQueryVariables>(
		CreditBureauAuthorizationsDocument,
		options
	);
}
export function useCreditBureauAuthorizationsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CreditBureauAuthorizationsQuery,
		CreditBureauAuthorizationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CreditBureauAuthorizationsQuery,
		CreditBureauAuthorizationsQueryVariables
	>(CreditBureauAuthorizationsDocument, options);
}
export function useCreditBureauAuthorizationsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				CreditBureauAuthorizationsQuery,
				CreditBureauAuthorizationsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CreditBureauAuthorizationsQuery,
		CreditBureauAuthorizationsQueryVariables
	>(CreditBureauAuthorizationsDocument, options);
}
export type CreditBureauAuthorizationsQueryHookResult = ReturnType<
	typeof useCreditBureauAuthorizationsQuery
>;
export type CreditBureauAuthorizationsLazyQueryHookResult = ReturnType<
	typeof useCreditBureauAuthorizationsLazyQuery
>;
export type CreditBureauAuthorizationsSuspenseQueryHookResult = ReturnType<
	typeof useCreditBureauAuthorizationsSuspenseQuery
>;
export type CreditBureauAuthorizationsQueryResult = Apollo.QueryResult<
	CreditBureauAuthorizationsQuery,
	CreditBureauAuthorizationsQueryVariables
>;
export function refetchCreditBureauAuthorizationsQuery(
	variables?: CreditBureauAuthorizationsQueryVariables
) {
	return { query: CreditBureauAuthorizationsDocument, variables: variables };
}
